/*
SLB GENERATED FILE — DO NOT EDIT
Project: Saam Law BaseStation (SLB)
Build-Version: SLB_V4_133_JEE_CHAT_TRANSACTION_CONSOLE_20260910_01
Output: assets/slb.temple.js
Source: slb_src/slices/temple/
Build: slb_build/build_temple.mjs
Built: 2026-09-19 16:53:59.067Z
Content-SHA256: 9be0dacac8e7722d75fc1c9bc196e2e34aa571a503753f63618b0346ddb69d72
Content-SHA256-12: 9be0dacac8e7
*/

/* MIGRATED SOURCE
   Original asset: /assets/slb.temple.js
   Note: This file was copied as-is to bring the module under the slice build pipeline.
   Safe refactor can be done later by splitting into multiple numbered parts.
*/

/* SLB Temple (FU Requests) — UI v4 (2026-01-06)
 * - Optimistic checkout (clears basket immediately; restores on failure)
 * - Archive DONE/CANCELLED orders (user + admin) + "Show archived" toggles
 * - Temple Builder blocks (admin): editable Featured sections (add more sections/cards)
 */
(function(){
  'use strict';

  const qs = (s, root)=> (root||document).querySelector(s);
  const qsa = (s, root)=> Array.from((root||document).querySelectorAll(s));
  const esc = (s)=> String(s==null?'':s).replace(/[&<>"']/g, c=>({
    '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'
  }[c]));
  const fmt0 = (n)=> (Math.round(Number(n||0)||0)).toLocaleString();

  const getApp = ()=> (window.SLB_APP || window.SLBAPP || window.slbApp || null);

  const STATE = {
    settings:{},
    catalog:[],
    byId:{},
    listItems:[],
    featured:[],
    blocks:[],   // Temple Builder blocks (active)
    my:[],
    adm:[],
    blocksAll:[]
  };

  async function rpc(action,args,opts){
    const app=getApp();
    if(!app || !app.rpc) throw new Error('SLB app not ready');
    return await app.rpc(action, args||{}, opts||{});
  }

  function fmtShortDateTime_(iso){
    if(!iso) return '';
    try{
      const d = new Date(iso);
      if(!isFinite(d.getTime())) return '';
      const date = new Intl.DateTimeFormat('en-US', { month:'short', day:'numeric', year:'numeric' }).format(d);
      let time = new Intl.DateTimeFormat('en-US', { hour:'numeric', minute:'2-digit', hour12:true }).format(d);
      time = String(time).replace(/\s?(AM|PM)$/i, (m)=> m.trim().toLowerCase());
      return date + ' @ ' + time;
    }catch(_e){
      return '';
    }
  }

  async function refreshDash(){
    const app=getApp();
    if(!app) return;
    try{ if(app.refreshDashboardLite) await app.refreshDashboardLite({forceFresh:1}); }catch(_e){}
  }

  function setBoxMsg(el, ok, msg){
    if(!el) return;
    const txt = String(msg||'').trim();
    if(!txt){ el.style.display='none'; el.classList.remove('ok','bad'); el.textContent=''; return; }
    el.style.display='block';
    el.classList.toggle('ok', !!ok);
    el.classList.toggle('bad', !ok);
    el.textContent = txt;
  }
  const setMsg = (ok,msg)=> setBoxMsg(qs('#slbTempleMsg'), ok, msg);
  const setMyMsg = (ok,msg)=> setBoxMsg(qs('#slbTempleMyMsg'), ok, msg);
  const setAdmMsg = (ok,msg)=> {
    const el = qs('#slbTempleAdmMsg');
    if(!el) return;
    el.style.color = ok ? 'inherit' : '#b00000';
    el.textContent = String(msg||'');
  };
  const setBlocksMsg = (ok,msg)=> {
    const el = qs('#slbTempleBlocksMsg');
    if(!el) return;
    el.style.color = ok ? 'inherit' : '#b00000';
    el.textContent = String(msg||'');
  };

  function getPouchId(){ return String((qs('#slbTemplePouchSel')||{}).value||'').trim(); }
  function setPouchId(v){ const sel=qs('#slbTemplePouchSel'); if(sel) sel.value = v||''; }
  function getGlobalNote(){ return String((qs('#slbTempleGlobalNote')||{}).value||'').trim(); }
  function setGlobalNote(v){ const el=qs('#slbTempleGlobalNote'); if(el) el.value = v||''; }

  function buildIndex(){
    STATE.byId={};
    STATE.featured=[];
    STATE.listItems=[];
    for(const it of (STATE.catalog||[])){
      const id=String(it.itemId||'').trim();
      if(!id) continue;
      STATE.byId[id.toLowerCase()] = it;

      const hasActive = !(it.activeFlag === undefined || it.activeFlag === null || it.activeFlag === '');
      const active = hasActive ? (Number(it.activeFlag||0) ? 1 : 0) : 1;
      if(!active) continue;

      const t=String(it.type||'').toUpperCase();
      if(t==='FEATURED') STATE.featured.push(it);
      if(t==='LIST') STATE.listItems.push(it);
    }
    const bySort = (a,b)=> (Number(a.sortOrder||0)-Number(b.sortOrder||0)) || String(a.title||'').localeCompare(String(b.title||''));
    STATE.featured.sort(bySort);
    STATE.listItems.sort(bySort);
  }

  function renderPouches(pouches){
    const sel=qs('#slbTemplePouchSel');
    if(!sel) return;
    const prev=String(sel.value||'').trim();
    const rows = Array.isArray(pouches) ? pouches : [];
    sel.innerHTML = '<option value="">Select pouch…</option>' + rows.map(p=>{
      const id=String(p.accountId||p.walletId||'').trim();
      const name=String(p.name||p.label||id||'').trim();
      const bal=Number(p.balance||0)||0;
      return `<option value="${esc(id)}">${esc(name)} — ${fmt0(bal)} stones</option>`;
    }).join('');
    if(prev && qs(`option[value="${CSS.escape(prev)}"]`, sel)) sel.value = prev;
  }

  // ===== Featured blocks =====
  function fallbackBlocks(){
    // If blocks sheet isn't ready yet, fall back to original 4-bucket layout.
    return [
      { blockId:'sec_boost', blockType:'SECTION', title:'Boost FUs', activeFlag:1, sortOrder:10, config:{ columns:2, items:["vision-boost","wealth-boost","luck-boost","wellness-boost"] } },
      { blockId:'sec_exorcism', blockType:'SECTION', title:'Exorcism / Clearing FUs', activeFlag:1, sortOrder:20, config:{ columns:2, items:["cleansing","exorcism-fu","villain-repelling","calamity-dissolving"] } },
      { blockId:'sec_protection', blockType:'SECTION', title:'Protection FUs', activeFlag:1, sortOrder:30, config:{ columns:2, items:["travel-protection","harmony-protection","property-protection","personal-protection"] } },
      { blockId:'sec_special', blockType:'SECTION', title:'Special', activeFlag:1, sortOrder:40, config:{ columns:2, items:["tai-sui","custom-fu"] } }
    ];
  }

function mkCard(it){
  const id=String(it.itemId||'').trim();
  const title=String(it.title||'').trim();
  const min=Number(it.minOffer||108)||108;
  const details=String(it.details||'').trim();
  const blurb=String(it.blurb||'').trim();
  const isCustom = id === 'custom-fu';
  const isTaiSui = id === 'tai-sui';

  // Special: Fan Tai Sui FU must be requested via the Fan Tai Sui calculator page
  if(isTaiSui){
    return `
      <article class="fu-item" data-item="${esc(id)}">
        <div>
          <h4>${esc(title)}</h4>
          <div class="sub">Min ${fmt0(min)} stones</div>
          ${blurb ? `<div class="desc" style="margin-top:8px;">${esc(blurb)}</div>` : ''}
          ${details ? `<div class="desc" style="margin-top:8px;">${esc(details)}</div>` : ''}
        </div>

        <div class="fu-row">
          <a class="btn primary" href="#tab=bagwaHall&bagwa=fanTaiSui" style="display:block;width:100%;text-align:center;">
            Continue with Fan Tai Sui
          </a>
        </div>
      </article>
    `;
  }

  return `
    <article class="fu-item" data-item="${esc(id)}">
      <div>
        <h4>${esc(title)}</h4>
        <div class="sub">Min ${fmt0(min)} stones</div>
        ${blurb ? `<div class="desc" style="margin-top:8px;">${esc(blurb)}</div>` : ''}
        ${details ? `<div class="desc" style="margin-top:8px;">${esc(details)}</div>` : ''}
      </div>

      ${isCustom ? `
        <div>
          <label class="sub">Your case details (optional)</label>
          <textarea class="tCustomMsg" placeholder="Write your situation / what you need..."></textarea>
        </div>
      ` : ''}

      <div class="fu-row">
        <div style="display:flex;flex-direction:column;gap:6px;">
          <label>Qty</label>
          <input class="tQty miniInput" type="number" min="1" max="999" value="1">
        </div>
        <div style="display:flex;flex-direction:column;gap:6px;">
          <label>Top-up</label>
          <input class="tTop miniInput" type="number" min="0" max="999999" value="0">
        </div>

        <button class="fu-pill tFly" type="button" aria-pressed="false" title="Fly FU: OFF"><span class="dot"></span><span>Fly FU</span></button>
        <button class="btn primary mini tAdd" type="button">Add</button>
      </div>
    </article>
  `;
}


  function renderFeatured(){
    const mount = qs('#slbTempleFeaturedMount');
    if(!mount) return;

    const blocks = (STATE.blocks && STATE.blocks.length) ? STATE.blocks : fallbackBlocks();
    const sections = (blocks||[]).filter(b=>String(b.blockType||'').toUpperCase()==='SECTION' && Number(b.activeFlag||0));
    if(!sections.length){
      mount.innerHTML = '<div class="msg bad">No featured sections are configured.</div>';
      return;
    }

    const sectionHtml = sections.map(b=>{
      const cfg = b.config || {};
      const cols = Math.max(1, Math.min(3, Number(cfg.columns||2)||2));
      const items = Array.isArray(cfg.items) ? cfg.items : [];
      const cards = items.map(id=>{
        const it = STATE.byId[String(id||'').toLowerCase()];
        if(!it) return '';
        return mkCard(it);
      }).join('');
      const sub = String(cfg.note||'').trim();
      return `
        <div class="fu-section open" data-sec="${esc(b.blockId||'')}">
          <div class="fu-section-header">
            <div>
              <div class="fu-section-title">${esc(b.title||'')}</div>
              ${sub ? `<div class="fu-section-sub">${esc(sub)}</div>` : ''}
            </div>
            <div class="fu-section-toggle"><span class="fu-chev">▸</span></div>
          </div>
          <div class="fu-section-body">
            <div class="fu-grid" style="--cols:${cols};">
              ${cards || '<div class="sub">No items in this section.</div>'}
            </div>
          </div>
        </div>
      `;
    }).join('');

    mount.innerHTML = sectionHtml;
    wireSectionToggles(mount);
    wireFeaturedAdd(mount);
  }

  function wireSectionToggles(root){
    qsa('.fu-section-header', root||document).forEach(h=>{
      if(h.__wired) return;
      h.__wired = true;
      h.addEventListener('click', (ev)=>{
        // avoid toggle when clicking inside buttons/inputs
        const t = ev.target;
        if(t && (t.closest('button') || t.closest('input') || t.closest('textarea') || t.closest('select'))) return;
        const sec=h.closest('.fu-section');
        if(sec) sec.classList.toggle('open');
      });
    });
  }

  function wireFeaturedAdd(root){
    qsa('.tFly', root).forEach(btn=>{
      if(btn.__wired) return;
      btn.__wired = true;
      btn.addEventListener('click', (ev)=>{
        ev.stopPropagation();
        const on = btn.getAttribute('aria-pressed') === 'true';
        btn.setAttribute('aria-pressed', on ? 'false' : 'true');
      });
    });

    qsa('.tAdd', root).forEach(btn=>{
      if(btn.__wired) return;
      btn.__wired = true;
      btn.addEventListener('click', (ev)=>{
        ev.stopPropagation();
        const card = btn.closest('[data-item]');
        if(!card) return;
        const itemId = card.getAttribute('data-item');
        const qty = Math.max(1, Math.min(999, Number((qs('.tQty', card)||{}).value||1)||1));
        const top = Math.max(0, Math.min(999999, Number((qs('.tTop', card)||{}).value||0)||0));
        const fly = (qs('.tFly', card)||{}).getAttribute('aria-pressed') === 'true' ? 1 : 0;
        const customMsg = String((qs('.tCustomMsg', card)||{}).value||'').trim();

        // Add to basket (fills the trailing empty row to avoid zebra empties)
        addLineToBasket_({ itemId, qty, top, fly, note: customMsg });

        openCustomAndScroll();
        setMsg(true, 'Added to basket.');
        setTimeout(()=> setMsg(true,''), 1200);
      });
    });
  }

  function openCustomAndScroll(){
    const sec = qs('.fu-section[data-sec="custom"]');
    if(sec) sec.classList.add('open');
    const target = qs('#slbTempleCoRows') || sec;
    if(target) target.scrollIntoView({behavior:'smooth', block:'start'});
  }

  // ===== Custom list rows (134 list) =====
  function listOptionsHtml(selectedId){
    const sel = String(selectedId||'').trim().toLowerCase();
    let html = '<option value="">Select FU…</option>';
    for(const it of (STATE.listItems||[])){
      const id=String(it.itemId||'').trim();
      const title=String(it.title||id||'').trim();
      const min=Number(it.minOffer||108)||108;
      const isSel = sel && sel === id.toLowerCase();
      html += `<option value="${esc(id)}" ${isSel?'selected':''}>${esc(title)} — Min ${fmt0(min)}</option>`;
    }
    return html;
  }

  function rowHtml(line){
    const itemId = line && line.itemId ? String(line.itemId) : '';
    const qty = line && line.qty ? Number(line.qty) : 1;
    const top = line && line.top ? Number(line.top) : 0;
    const fly = line && line.fly ? 1 : 0;
    const note = line && line.note ? String(line.note) : '';

    return `
      <div class="tRow fu-co-row" data-row="1">
        <div><select class="tSel">${listOptionsHtml(itemId)}</select></div>
        <div><input class="tQty" type="number" min="1" max="999" value="${esc(qty)}"></div>
        <div><input class="tTop" type="number" min="0" max="999999" value="${esc(top)}"></div>
        <div><button class="fu-pill tFly" type="button" aria-pressed="${fly?'true':'false'}" title="Fly FU"><span class="dot"></span><span>Fly FU</span></button></div>
        <div><input class="tNote" type="text" placeholder="Line note (optional)" value="${esc(note)}"></div>
        <div><button class="fu-x tDel" type="button" title="Remove">✕</button></div>
      </div>
    `;
  }

  function addRow(line){
    const co = qs('#slbTempleCoRows');
    if(!co) return;
    const tmp = document.createElement('div');
    tmp.innerHTML = rowHtml(line);
    const row = tmp.firstElementChild;
    co.appendChild(row);

    // If this item isn't part of the 134-list dropdown, inject it (supports Featured → basket).
    try{
      const itemId = String(line && line.itemId || '').trim();
      if(itemId){
        const sel = qs('.tSel', row);
        if(sel && !qs(`option[value="${CSS.escape(itemId)}"]`, sel)){
          const it = STATE.byId[itemId.toLowerCase()] || {};
          const title = String(it.title||itemId);
          const min = Number(it.minOffer||108)||108;
          const opt = document.createElement('option');
          opt.value = itemId;
          opt.textContent = `${title} — Min ${fmt0(min)}`;
          sel.appendChild(opt);
        }
        if(sel) sel.value = itemId;
      }
    }catch(_e){}

    wireRow(row);
  }
  function ensureRowOption_(sel, itemId){
    try{
      if(!sel || !itemId) return;
      if(qs(`option[value="${CSS.escape(itemId)}"]`, sel)) return;
      const it = STATE.byId[itemId.toLowerCase()] || {};
      const title = String(it.title||itemId);
      const min = Number(it.minOffer||108)||108;
      const opt = document.createElement('option');
      opt.value = itemId;
      opt.textContent = `${title} — Min ${fmt0(min)}`;
      sel.appendChild(opt);
    }catch(_e){}
  }

  function setRowFromLine_(row, line){
    if(!row || !line) return;
    const itemId = String(line.itemId||'').trim();
    const qty = Math.max(1, Math.min(999, Number(line.qty||1)||1));
    const top = Math.max(0, Math.min(999999, Number(line.top||0)||0));
    const fly = line.fly ? 1 : 0;
    const note = String(line.note||'').trim();

    const sel = qs('.tSel', row);
    if(sel && itemId){
      ensureRowOption_(sel, itemId);
      sel.value = itemId;
    }
    const q = qs('.tQty', row); if(q) q.value = String(qty);
    const t = qs('.tTop', row); if(t) t.value = String(top);
    const f = qs('.tFly', row); if(f) f.setAttribute('aria-pressed', fly?'true':'false');
    const n = qs('.tNote', row); if(n) n.value = note;
  }

  // Add a line into the basket WITHOUT creating zebra empty rows.
  // Rule: if the last row is empty, fill it; otherwise append a new row.
  function addLineToBasket_(line){
    const co = qs('#slbTempleCoRows');
    if(!co) return;
    const rows = qsa('.tRow', co);
    if(rows.length){
      const last = rows[rows.length-1];
      const lastVal = String((qs('.tSel', last)||{}).value||'').trim();
      if(!lastVal){
        setRowFromLine_(last, line);
        wireRow(last);
        ensureTrailingEmptyRow();
        recalcGrand();
        return;
      }
    }
    addRow(line);
    ensureTrailingEmptyRow();
    recalcGrand();
  }


  function wireRow(row){
    const sel = qs('.tSel', row);
    const del = qs('.tDel', row);
    const fly = qs('.tFly', row);

    if(sel && !sel.__wired){
      sel.__wired = true;
      sel.addEventListener('change', ()=>{
        ensureTrailingEmptyRow();
        recalcGrand();
      });
    }
    if(del && !del.__wired){
      del.__wired = true;
      del.addEventListener('click', ()=>{
        row.remove();
        ensureTrailingEmptyRow();
        recalcGrand();
      });
    }
    if(fly && !fly.__wired){
      fly.__wired = true;
      fly.addEventListener('click', ()=>{
        const on = fly.getAttribute('aria-pressed') === 'true';
        fly.setAttribute('aria-pressed', on ? 'false' : 'true');
      });
    }
    qsa('input', row).forEach(inp=>{
      if(inp.__wired) return;
      inp.__wired = true;
      inp.addEventListener('input', ()=>{ recalcGrand(); });
    });
  }

  function getLines(){
    const co = qs('#slbTempleCoRows');
    if(!co) return [];
    const out = [];
    qsa('.tRow', co).forEach(row=>{
      const itemId = String((qs('.tSel', row)||{}).value||'').trim();
      if(!itemId) return;
      const qty = Math.max(1, Math.min(999, Number((qs('.tQty', row)||{}).value||1)||1));
      const top = Math.max(0, Math.min(999999, Number((qs('.tTop', row)||{}).value||0)||0));
      const fly = (qs('.tFly', row)||{}).getAttribute('aria-pressed') === 'true' ? 1 : 0;
      const note = String((qs('.tNote', row)||{}).value||'').trim();
      out.push({ itemId, qty, topUp: top, flyFlag: fly, note });
    });
    return out;
  }

  function setLines(lines){
    const co = qs('#slbTempleCoRows');
    if(!co) return;
    co.innerHTML = '';
    (lines||[]).forEach(ln=>{
      addRow({ itemId: ln.itemId, qty: ln.qty, top: ln.topUp, fly: ln.flyFlag, note: ln.note });
    });
    ensureTrailingEmptyRow();
    recalcGrand();
  }

  function ensureTrailingEmptyRow(){
    const co = qs('#slbTempleCoRows');
    if(!co) return;
    const rows = qsa('.tRow', co);
    if(!rows.length){ addRow(); return; }
    const last = rows[rows.length-1];
    const lastVal = String((qs('.tSel', last)||{}).value||'').trim();
    if(lastVal) addRow();
  }

  function recalcGrand(){
    const el = qs('#slbTempleCustomGrandTotal');
    if(!el) return;
    const lines = getLines();
    let sum = 0;
    for(const ln of lines){
      const it = STATE.byId[String(ln.itemId||'').toLowerCase()] || {};
      const min = Number(it.minOffer||108)||108;
      const qty = Number(ln.qty||1)||1;
      const top = Number(ln.topUp||0)||0;
      sum += qty * (min + top);
    }
    el.textContent = fmt0(sum);
  }

  // ===== Checkout (optimistic) =====
  async function submitBulk(){
    const btn = qs('#slbTempleBulkSubmitBtn');
    if(!btn || btn.disabled) return;

    const pouchId = getPouchId();
    if(!pouchId){
      setMsg(false, 'Select which Cosmic Pouch to pay from.');
      return;
    }
    const lines = getLines();
    if(!lines.length){
      setMsg(false, 'Pick at least 1 FU.');
      return;
    }
    for(const ln of lines){
      const it = STATE.byId[String(ln.itemId||'').toLowerCase()];
      if(!it){ setMsg(false, 'Invalid FU selected: ' + ln.itemId); return; }
      const min = Number(it.minOffer||108)||108;
      const qty = Number(ln.qty||1)||1;
      const top = Number(ln.topUp||0)||0;
      const offer = qty * (min + top);
      if(offer < qty*min){ setMsg(false, 'Offering below minimum for ' + (it.title||ln.itemId)); return; }
    }

    // Snapshot for rollback
    const snapshot = {
      pouchId,
      globalNote: getGlobalNote(),
      lines: lines.map(x=>({ ...x }))
    };

    // Optimistic clear
    btn.disabled = true;
    const oldLabel = btn.textContent;
    btn.textContent = 'Submitting…';
    setMsg(true, 'Submitting…');
    try{
      setLines([]); // clears + adds empty row via ensure
      setGlobalNote('');
      // keep pouch selection so user knows which pouch used; restore on failure if needed

      const payload = {
        payAccountId: pouchId,
        globalNote: snapshot.globalNote,
        lines: snapshot.lines.map(ln=>({
          itemId: ln.itemId,
          qty: ln.qty,
          topUp: ln.topUp,
          flyFlag: ln.flyFlag,
          note: ln.note
        }))
      };

      const out = await rpc('templeOrderCreateBulk', payload);
      if(out && out.__queued){
        setMsg(true, 'Queued (offline). Your basket is cleared. Tap Sync when you are online.');
        try{ const w=qs('#slbTempleWorshipNext'); if(w) w.style.display='block'; }catch(_e){}
        return;
      }
      setMsg(true, 'Submitted. Your basket is cleared.');
      try{ const w=qs('#slbTempleWorshipNext'); if(w) w.style.display='block'; }catch(_e){}
      try{ await loadMy(); }catch(_e){}
      try{ await refreshDash(); }catch(_e){}
    }catch(e){
      // Rollback
      setLines(snapshot.lines);
      setGlobalNote(snapshot.globalNote);
      setPouchId(snapshot.pouchId);
            try{ const w=qs('#slbTempleWorshipNext'); if(w) w.style.display='none'; }catch(_e){}
setMsg(false, e && e.message ? e.message : String(e));
    }finally{
      btn.disabled = false;
      btn.textContent = oldLabel;
    }
  }

  function fmtTempleTime(iso){
    try{
      const d = new Date(iso);
      if(!d || isNaN(d.getTime())) return '';
      const months=['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
      let h=d.getHours();
      const m=String(d.getMinutes()).padStart(2,'0');
      const ap=h>=12?'pm':'am';
      h=h%12; if(h===0) h=12;
      return `${months[d.getMonth()]} ${d.getDate()}, ${d.getFullYear()} @ ${h}:${m}${ap}`;
    }catch(e){ return ''; }
  }

// ===== My orders (user) =====
  async function loadMy(){
    const body = qs('#slbTempleMyBody');
    if(!body) return;
    const showArchived = (qs('#slbTempleShowArchived')||{}).checked ? 1 : 0;
    try{
      const rows = await rpc('templeMyOrders', { limit: 200, showArchived });
      STATE.my = rows || [];
      body.innerHTML = (STATE.my||[]).map(r=>{
        const t = r.timeISO ? fmtTempleTime(r.timeISO) : '';
        const fly = Number(r.flyFlag||0) ? 'YES' : '';
        const st = String(r.status||'').toUpperCase();
        const isArch = Number(r.archivedFlag||0) ? 1 : 0;
        const canArchive = (st === 'DONE' || st === 'CANCELLED') && !isArch;
        const note = esc(r.note||'');
        const oid = esc(r.orderId||'');
        const title = esc(r.title||r.itemId||'');
        const detailId = `uDetail_${oid}`;
        return `<tr class="uRow" data-oid="${oid}" data-open="0" aria-controls="${detailId}">
          <td class="mono"><span class="uChev">›</span>${esc(t)}</td>
          <td>${title}</td>
          <td class="mono">${fmt0(r.qty||1)}</td>
          <td class="mono">${fmt0(r.offering||0)}</td>
          <td class="mono">${esc(fly)}</td>
          <td class="mono">${esc(st)} ${isArch?'<span class="mono">ARCH</span>':''}</td>
        </tr>
        <tr class="uDetail" id="${detailId}" style="display:none;">
          <td colspan="6">
            <div class="uDetailBox">
              <div class="uDetailGrid">
                <div>
                  <div class="uDetailLabel">Note</div>
                  <div class="uDetailText">${note||'<span class="sub">—</span>'}</div>
                </div>
                <div style="display:flex;gap:8px;justify-content:flex-end;flex-wrap:wrap;">
                  ${canArchive ? `<button class="btn soft mini uArchive" type="button">Archive</button>` : ''}
                </div>
              </div>
            </div>
          </td>
        </tr>`;
      }).join('');
      wireUserArchive(body);
      wireUserToggle(body);
      setMyMsg(true, `Loaded ${STATE.my.length||0} rows.`);
    }catch(e){
      setMyMsg(false, e && e.message ? e.message : String(e));
    }
  }

  function wireUserToggle(body){
    qsa('tr.uRow', body).forEach(tr=>{
      if(tr.__toggleWired) return;
      tr.__toggleWired = true;
      tr.addEventListener('click', (ev)=>{
        // don't toggle when clicking buttons/links inside row
        if(ev.target && (ev.target.closest('button') || ev.target.closest('a') || ev.target.closest('input') || ev.target.closest('select') || ev.target.closest('textarea'))) return;
        const detail = tr.nextElementSibling;
        if(!detail || !detail.classList || !detail.classList.contains('uDetail')) return;
        const open = tr.getAttribute('data-open') === '1';
        if(open){
          detail.style.display = 'none';
          tr.setAttribute('data-open','0');
          tr.classList.remove('is-open');
        }else{
          detail.style.display = '';
          tr.setAttribute('data-open','1');
          tr.classList.add('is-open');
        }
      });
    });
  }

function wireUserArchive(body){
    qsa('.uArchive', body).forEach(btn=>{
      if(btn.__wired) return;
      btn.__wired = true;
      btn.addEventListener('click', async (ev)=>{
        const detailTr = ev.target.closest('tr.uDetail');
        const mainTr = detailTr ? detailTr.previousElementSibling : ev.target.closest('tr[data-oid]');
        if(!mainTr) return;
        const orderId = mainTr.getAttribute('data-oid');
        const main = tr.previousElementSibling && tr.previousElementSibling.classList && tr.previousElementSibling.classList.contains('aRow') ? tr.previousElementSibling : null;
        const oldHTML = (main?main.outerHTML:'') + tr.outerHTML;
        const parent = tr.parentElement;
        if(main) main.remove();
        tr.remove();
        setMyMsg(true, 'Archiving…');

        try{
          const out = await rpc('templeOrderArchive', { orderId });
          setMyMsg(true, (out && out.__queued) ? 'Queued (offline). Will archive when synced.' : 'Archived.');
          // also update STATE.my
          STATE.my = (STATE.my||[]).filter(x=>String(x.orderId||'') !== String(orderId||''));
        }catch(e){
          // rollback row
          if(parent){
            const tmp=document.createElement('tbody');
            tmp.innerHTML = oldHTML;
            parent.appendChild(tmp.firstElementChild);
          }
          setMyMsg(false, e && e.message ? e.message : String(e));
        }
      });
    });
  }

  // ===== Admin orders =====
  async function adminRefresh(){
  const body=qs('#slbTempleAdmBody');
  if(!body) return;
  const showArchived = (qs('#slbTempleAdmShowArchived')||{}).checked ? 1 : 0;
  const hideDone = (qs('#slbTempleAdmHideDone')||{}).checked ? 1 : 0;
  try{
    const q=String((qs('#slbTempleAdmQ')||{}).value||'').trim();
    const status=String((qs('#slbTempleAdmStatus')||{}).value||'').trim();
    // IMPORTANT: Temple Admin must always show the latest orders.
    // The SLB offline layer is cache-first for some reads; bypass it here.
    const rows=await rpc('adminTempleOrdersList',{ q, status, limit: 500, showArchived }, { noCacheFirst: 1, noCache: 1 });
    STATE.adm=rows||[];

    // Always sort latest first (server order may vary after restores).
    (STATE.adm||[]).sort((a,b)=>{
      const ta = new Date(a && (a.timeISO||a.time||a.ts||'') || 0).getTime() || 0;
      const tb = new Date(b && (b.timeISO||b.time||b.ts||'') || 0).getTime() || 0;
      return tb - ta;
    });

    const rowsForRender = hideDone ? (STATE.adm||[]).filter(r => String(r && r.status || '').trim().toUpperCase() !== 'DONE') : (STATE.adm||[]);

    body.innerHTML = rowsForRender.map(r=>{
      const t = fmtShortDateTime_(r.timeISO);
      const st=String(r.status||'NEW').toUpperCase();
      const fly = Number(r.flyFlag||0) ? 'YES' : '';
      const arch = Number(r.archivedFlag||0) ? '<span class="mono" style="margin-left:8px;opacity:.85;">ARCH</span>' : '';
      const canArchive = (st === 'DONE' || st === 'CANCELLED') && !Number(r.archivedFlag||0);
      const refunded = String(r.refundStatus||'').trim().toUpperCase() === 'REFUNDED';
      const refundAmount = Number(r.refundAmount||0) || 0;
      const opts=['NEW','IN_PROGRESS','DONE','CANCELLED'].map(s=>`<option value="${s}" ${s===st?'selected':''}>${s}</option>`).join('');
      const userNote = String(r.note||'').trim();
      const item = (r.title||r.itemId||'');
      return `
        <tr class="aRow" data-oid="${esc(r.orderId||'')}" data-st="${esc(st)}" title="Click to expand">
          <td class="mono">${esc(t)}</td>
          <td style="text-align:center;">
            ${r.orderId ? `<button class="slbCopyBtn slbCopyTiny tpCopyBtn" data-copy="${esc(r.orderId||'')}" title="Copy Order ID" aria-label="Copy Order ID"><span class="slbIco">⧉</span></button>` : ''}
          </td>
          <td class="mono">${esc(r.callsign||'')}</td>
          <td>${esc(item)}</td>
          <td class="mono">${fmt0(r.qty||1)}</td>
          <td class="mono">${fmt0(r.offering||0)}</td>
          <td class="mono">${esc(fly)}</td>
          <td>
            <span class="aStBadge mono">${esc(st)}</span>
            ${arch}
          </td>
        </tr>
        <tr class="aDetail" data-oid="${esc(r.orderId||'')}" data-st="${esc(st)}" style="display:none;">
          <td colspan="8">
            <div class="slbTempleAdmExpand">
              <div class="slbTempleAdmExpandGrid">
                <div>
                  <div class="slbTempleAdmLabel">User note</div>
                  <div class="slbTempleAdmBox">${esc(userNote||'-')}</div>
                </div>
                <div>
                  <div class="slbTempleAdmLabel">Admin note</div>
                  <input class="aNote" value="${esc(r.adminNote||'')}" style="width:100%;">
                </div>
                <div>
                  <div class="slbTempleAdmLabel">Status</div>
                  <select class="aSt" style="width:100%;" ${refunded?'disabled':''}>${opts}</select>
                </div>
                <div>
                  <div class="slbTempleAdmLabel">Stone refund</div>
                  <div class="slbTempleAdmBox">${refunded ? `${fmt0(refundAmount)} stones returned${r.refundAccountId ? ` to ${esc(r.refundAccountId)}` : ''}${r.refundedAt ? `<br><small>${esc(fmtShortDateTime_(r.refundedAt))}</small>` : ''}` : 'Not refunded'}</div>
                </div>
              </div>

              <div class="slbTempleAdmActions">
                <button class="btn soft mini aSave" type="button" ${refunded?'disabled':''}>Set</button>
                <button class="btn soft mini aResend" type="button">Resend</button>
                ${!refunded ? `<button class="btn mini aCancelRefund" type="button" style="background:#8f2f2f;color:#fff;border-color:#b54b4b;">CANCEL + REFUND</button>` : ''}
                ${canArchive ? `<button class="btn soft mini aArchive" type="button">Archive</button>` : ''}
              </div>
            </div>
          </td>
        </tr>
      `;
    }).join('');

    wireAdminExpand(body);
    wireAdminRowActions(body);
    setAdmMsg(true, `Loaded ${STATE.adm.length||0} rows.`);
  }catch(e){
    setAdmMsg(false, e && e.message ? e.message : String(e));
  }
}

function wireAdminExpand(body){
  if(!body || body.__expWired) return;
  body.__expWired = true;

  const isInteractive = (el)=> !!(el && el.closest && el.closest('button,select,input,textarea,a,label'));

  const openDetail = (row, detail)=>{
    detail.style.display = 'table-row';
    detail.classList.add('isOpen');
    row.classList.add('isOpen');
  };
  const closeDetail = (row, detail)=>{
    detail.style.display = 'none';
    detail.classList.remove('isOpen');
    row.classList.remove('isOpen');
  };
  const toggleDetail = (row, detail)=>{
    const isOpen = detail.classList.contains('isOpen') || (getComputedStyle(detail).display !== 'none');
    if(isOpen) closeDetail(row, detail);
    else openDetail(row, detail);
  };

  body.addEventListener('click', (ev)=>{
    if(isInteractive(ev.target)) return;

    const aRow = ev.target.closest('tr.aRow');
    const aDetail = ev.target.closest('tr.aDetail');

    if(aRow && body.contains(aRow)){
      const detail = aRow.nextElementSibling;
      if(detail && detail.classList.contains('aDetail')){
        toggleDetail(aRow, detail);
      }
      return;
    }

    if(aDetail && body.contains(aDetail)){
      // Collapse when clicking the expanded area background
      const row = aDetail.previousElementSibling;
      if(row && row.classList && row.classList.contains('aRow')){
        closeDetail(row, aDetail);
      }else{
        aDetail.style.display='none';
        aDetail.classList.remove('isOpen');
      }
      return;
    }
  });

  // Prevent row toggle when using controls inside expanded panel
  // IMPORTANT: do this in bubble phase, not capture phase.
  // Capture-phase stopPropagation blocks the target button handlers themselves,
  // which makes Set / Resend / Archive appear dead.
  body.addEventListener('click', (ev)=>{
    if(isInteractive(ev.target)) ev.stopPropagation();
  });
}

function wireAdminRowActions(body){
  if(!body) return;
    qsa('.aSave', body).forEach(btn=>{
      if(btn.__wired) return;
      btn.__wired = true;
      btn.addEventListener('click', async (ev)=>{
        const tr=ev.target.closest('tr[data-oid]');
        const orderId=tr.getAttribute('data-oid');
        const prevSt = tr.getAttribute('data-st') || '';
        const sel = qs('.aSt', tr);
        const status = String((sel||{}).value||'').trim();
        const adminNote = String((qs('.aNote', tr)||{}).value||'').trim();

        if(status === 'CANCELLED' && prevSt !== 'CANCELLED'){
          const ok = window.confirm('Cancel this FU request and return its stones to the disciple?');
          if(!ok){ if(sel) sel.value = prevSt || 'NEW'; return; }
        }
        btn.disabled = true;
        btn.textContent = status === 'CANCELLED' ? 'Refunding…' : 'Saving…';
        setAdmMsg(true, status === 'CANCELLED' ? 'Cancelling and returning stones…' : 'Saving…');
        try{
          const out = await rpc('adminTempleOrderSetStatus',{ orderId, status, adminNote });
          tr.setAttribute('data-st', status);
          const main = tr.previousElementSibling && tr.previousElementSibling.classList && tr.previousElementSibling.classList.contains('aRow') ? tr.previousElementSibling : null;
          if(main){
            main.setAttribute('data-st', status);
            const b = qs('.aStBadge', main);
            if(b) b.textContent = status;
          }
          if(out && out.refunded){
            setAdmMsg(true, `${fmt0(out.refundAmount||0)} stones returned to the disciple. Request cancelled.`);
            await adminRefresh();
          }else{
            setAdmMsg(true, (out && out.__queued) ? 'Queued (offline). Will sync when online.' : 'Saved.');
          }
        }catch(e){
          // rollback select
          if(sel) sel.value = prevSt || 'NEW';
          setAdmMsg(false, e && e.message ? e.message : String(e));
        }finally{
          btn.disabled = false;
          btn.textContent = 'Set';
        }
      });
    });

    qsa('.aCancelRefund', body).forEach(btn=>{
      if(btn.__wired) return;
      btn.__wired = true;
      btn.addEventListener('click', async (ev)=>{
        const tr = ev.target.closest('tr[data-oid]');
        if(!tr) return;
        const orderId = tr.getAttribute('data-oid');
        const adminNote = String((qs('.aNote', tr)||{}).value||'').trim();
        if(!window.confirm('Cancel this FU request and return its stones to the disciple?')) return;
        btn.disabled = true;
        const oldTxt = btn.textContent;
        btn.textContent = 'REFUNDING…';
        setAdmMsg(true, 'Cancelling request and returning stones…');
        try{
          const out = await rpc('adminTempleOrderSetStatus',{ orderId, status:'CANCELLED', adminNote });
          setAdmMsg(true, `${fmt0((out||{}).refundAmount||0)} stones returned to the disciple. Request cancelled.`);
          await adminRefresh();
        }catch(e){
          setAdmMsg(false, e && e.message ? e.message : String(e));
        }finally{
          btn.disabled = false;
          btn.textContent = oldTxt || 'CANCEL + REFUND';
        }
      });
    });

    qsa('.aResend', body).forEach(btn=>{
      if(btn.__wired) return;
      btn.__wired = true;
      btn.addEventListener('click', async (ev)=>{
        const detailTr = ev.target.closest('tr.uDetail');
        const mainTr = detailTr ? detailTr.previousElementSibling : ev.target.closest('tr[data-oid]');
        if(!mainTr) return;
        const orderId = mainTr.getAttribute('data-oid');
        btn.disabled = true;
        const oldTxt = btn.textContent;
        btn.textContent = 'Sending…';
        setAdmMsg(true, 'Sending email…');
        try{
          const out = await rpc('adminTempleOrderResendEmail', { orderId });
          const sent = Number((out||{}).sent||0);
          if(sent){
            setAdmMsg(true, 'Email sent.');
          }else{
            const reason = String((out||{}).reason||'').toUpperCase();
            setAdmMsg(true, reason==='NO_EMAIL' ? 'User has no email on file.' : 'Not sent (user not opted in).');
          }
        }catch(e){
          setAdmMsg(false, e && e.message ? e.message : String(e));
        }finally{
          btn.disabled = false;
          btn.textContent = oldTxt || 'Resend';
        }
      });
    });


    qsa('.aArchive', body).forEach(btn=>{
      if(btn.__wired) return;
      btn.__wired = true;
      btn.addEventListener('click', async (ev)=>{
        const detailTr = ev.target.closest('tr.uDetail');
        const mainTr = detailTr ? detailTr.previousElementSibling : ev.target.closest('tr[data-oid]');
        if(!mainTr) return;
        const orderId = mainTr.getAttribute('data-oid');
        const main = tr.previousElementSibling && tr.previousElementSibling.classList && tr.previousElementSibling.classList.contains('aRow') ? tr.previousElementSibling : null;
        const oldHTML = (main?main.outerHTML:'') + tr.outerHTML;
        const parent = tr.parentElement;
        if(main) main.remove();
        tr.remove();
        setAdmMsg(true, 'Archiving…');

        try{
          const out = await rpc('adminTempleOrderArchive', { orderId });
          setAdmMsg(true, (out && out.__queued) ? 'Queued (offline). Will archive when synced.' : 'Archived.');
          STATE.adm = (STATE.adm||[]).filter(x=>String(x.orderId||'') !== String(orderId||''));
        }catch(e){
          if(parent){
            const tmp=document.createElement('tbody');
            tmp.innerHTML = oldHTML;
            parent.appendChild(tmp.firstElementChild);
          }
          setAdmMsg(false, e && e.message ? e.message : String(e));
        }
      });
    });

    qsa('.aArchive', body).forEach(btn=>{
      if(btn.__wired) return;
      btn.__wired = true;
      btn.addEventListener('click', async (ev)=>{
        const detailTr = ev.target.closest('tr.uDetail');
        const mainTr = detailTr ? detailTr.previousElementSibling : ev.target.closest('tr[data-oid]');
        if(!mainTr) return;
        const orderId = mainTr.getAttribute('data-oid');
        btn.disabled = true;
        const oldTxt = btn.textContent;
        btn.textContent = 'Archiving…';
        setAdmMsg(true, 'Archiving…');
        try{
          const out = await rpc('adminTempleOrderArchive', { orderId });
          setAdmMsg(true, (out && out.__queued) ? 'Queued (offline). Will sync when online.' : 'Archived.');
          const main = tr.previousElementSibling && tr.previousElementSibling.classList && tr.previousElementSibling.classList.contains('aRow') ? tr.previousElementSibling : null;
          if(main) main.remove();
          tr.remove();
          STATE.adm = (STATE.adm||[]).filter(x=>String(x.orderId||'') !== String(orderId||''));
        }catch(e){
          setAdmMsg(false, e && e.message ? e.message : String(e));
        }finally{
          btn.disabled = false;
          btn.textContent = oldTxt || 'Archive';
        }
      });
    });
  }

  async function adminArchiveDone(){
    const btn = qs('#slbTempleAdmArchiveDoneBtn');
    if(!btn || btn.disabled) return;
    btn.disabled = true;
    const old = btn.textContent;
    btn.textContent = 'Archiving…';
    setAdmMsg(true, 'Archiving DONE orders…');
    try{
      const out = await rpc('adminTempleArchiveDone', { limit: 800 });
      if(out && out.__queued){
        setAdmMsg(true, 'Queued (offline). Will archive DONE orders when synced.');
        return;
      }
      const n = (out && out.archived) || 0;
      setAdmMsg(true, `Archived ${n} DONE orders.`);
      await adminRefresh();
    }catch(e){
      setAdmMsg(false, e && e.message ? e.message : String(e));
    }finally{
      btn.disabled = false;
      btn.textContent = old;
    }
  }

  // ===== Admin: Temple Builder blocks =====
  function blocksRowHtml(b){
    const id = String((b && b.blockId) || '').trim() || ('sec_' + Date.now());
    const title = String((b && b.title) || '').trim();
    const active = Number((b && b.activeFlag) ? 1 : 0) || 0;
    const sort = Number((b && b.sortOrder) || 0) || 0;
    const cfg = (b && b.config) ? b.config : {};
    const cols = Math.max(1, Math.min(3, Number(cfg.columns||2)||2));
    const items = Array.isArray(cfg.items) ? cfg.items : [];
    const csv = items.map(x=>String(x||'').trim()).filter(Boolean).join(', ');
    return `<tr class="bRow">
      <td><input class="bId" value="${esc(id)}" style="min-width:140px;"></td>
      <td><input class="bTitle" value="${esc(title)}" style="min-width:220px;"></td>
      <td style="text-align:center;"><input class="bActive" type="checkbox" ${active?'checked':''}></td>
      <td><input class="bSort" type="number" value="${esc(sort)}" style="width:90px;"></td>
      <td><input class="bCols" type="number" min="1" max="3" value="${esc(cols)}" style="width:90px;"></td>
      <td><input class="bItems" value="${esc(csv)}" style="min-width:520px;width:100%;"></td>
      <td style="text-align:center;"><button class="btn soft mini bDel" type="button">✕</button></td>
    </tr>`;
  }

  async function blocksLoad(){
    const body = qs('#slbTempleBlocksBody');
    if(!body) return;
    setBlocksMsg(true, 'Loading…');
    try{
      const out = await rpc('adminTempleBlocksGet', { includeInactive: 1 });
      const blocks = (out && out.blocks) || [];
      STATE.blocksAll = blocks;
      body.innerHTML = (blocks||[]).map(blocksRowHtml).join('');
      wireBlocksRows(body);
      setBlocksMsg(true, `Loaded ${blocks.length||0} blocks.`);
    }catch(e){
      setBlocksMsg(false, e && e.message ? e.message : String(e));
    }
  }

  function wireBlocksRows(body){
    qsa('.bDel', body).forEach(btn=>{
      if(btn.__wired) return;
      btn.__wired = true;
      btn.addEventListener('click', ()=>{ const tr=btn.closest('tr'); if(tr) tr.remove(); });
    });
  }

  function blocksCollect(){
    const body = qs('#slbTempleBlocksBody');
    if(!body) return [];
    const out = [];
    qsa('.bRow', body).forEach(tr=>{
      const blockId = String((qs('.bId', tr)||{}).value||'').trim();
      const title = String((qs('.bTitle', tr)||{}).value||'').trim();
      const activeFlag = (qs('.bActive', tr)||{}).checked ? 1 : 0;
      const sortOrder = Number((qs('.bSort', tr)||{}).value||0) || 0;
      const columns = Math.max(1, Math.min(3, Number((qs('.bCols', tr)||{}).value||2)||2));
      const itemsCsv = String((qs('.bItems', tr)||{}).value||'').trim();
      const items = itemsCsv ? itemsCsv.split(',').map(s=>String(s||'').trim()).filter(Boolean) : [];
      if(!blockId) return;
      out.push({ blockId, blockType:'SECTION', title, activeFlag, sortOrder, config:{ columns, items } });
    });
    return out;
  }

  async function blocksSave(){
    const btn = qs('#slbTempleBlocksSaveBtn');
    if(btn) btn.disabled = true;
    setBlocksMsg(true, 'Saving…');
    try{
      const blocks = blocksCollect();
      if(!blocks.length) throw new Error('No blocks to save.');
      const out = await rpc('adminTempleBlocksSaveAll', { blocks });
      if(out && out.__queued){
        setBlocksMsg(true, 'Queued (offline). Tap Sync when you are online.');
        return;
      }
      setBlocksMsg(true, 'Saved. Reloading Featured…');
      try{ await loadTemple(); }catch(_e){}
      setBlocksMsg(true, 'Saved.');
    }catch(e){
      setBlocksMsg(false, e && e.message ? e.message : String(e));
    }finally{
      if(btn) btn.disabled = false;
    }
  }

  function blocksAdd(){
    const body = qs('#slbTempleBlocksBody');
    if(!body) return;
    const b = { blockId: 'sec_' + Date.now(), blockType:'SECTION', title:'New Section', activeFlag:1, sortOrder: 999, config:{ columns:2, items:[] } };
    body.insertAdjacentHTML('beforeend', blocksRowHtml(b));
    wireBlocksRows(body);
  }

  // ===== Temple load =====
    function applyTempleOut(out){
      STATE.settings = (out && out.settings) || {};
      STATE.catalog = (out && out.catalog) || [];
      STATE.blocks = (out && out.blocks) || [];
      buildIndex();

      renderPouches(out && out.pouches);

      const rules=qs('#slbTempleRules');
      if(rules){
        const txt = String(STATE.settings.rulesText||'').trim();
        rules.textContent = txt || 'Minimum offering for each FU is 108. You can add extra stones to increase power. Temple orders MUST be paid from a Cosmic Pouch (a_*).';
      }

      // admin filter options
      const stSel=qs('#slbTempleAdmStatus');
      if(stSel){
        const opts=['','NEW','IN_PROGRESS','DONE','CANCELLED'].map(s=>`<option value="${s}">${s||'All Status'}</option>`).join('');
        stSel.innerHTML = opts;
      }

      renderFeatured();

      // init list rows
      const co=qs('#slbTempleCoRows');
      if(co && !qsa('.tRow', co).length){
        addRow();
        recalcGrand();
      }
      wireSectionToggles(); // includes custom section
    
  }

  async function loadTemple(){
    setMsg(true,'');
    var usedCache=false;

    // Cache-first: render cached templeGet instantly, then refresh in background.
    try{
      var meta = (window.SLB_OFFLINE && window.SLB_OFFLINE.peekReadMeta) ? window.SLB_OFFLINE.peekReadMeta('templeGet', {}) : null;
      if(meta && meta.data){
        usedCache = true;
        try{ applyTempleOut(meta.data); }catch(_e){}
      }
    }catch(_e){}

    try{
      const out = await rpc('templeGet', {});
      applyTempleOut(out);
    }catch(e){
      if(!usedCache) setMsg(false, e && e.message ? e.message : String(e));
      else console.warn("Temple refresh failed:", e);
    }
  }

  // ===== CSV =====
  function dlCsv(filename, rows){
    const csv = rows.map(r=>r.map(cell=>{
      const s=String(cell==null?'':cell);
      const needs = /[",\n]/.test(s);
      return needs ? '"' + s.replace(/"/g,'""') + '"' : s;
    }).join(',')).join('\n');
    const blob = new Blob(["\ufeff"+csv], {type:'text/csv;charset=utf-8;'});
    const url = URL.createObjectURL(blob);
    const a=document.createElement('a');
    a.href=url;
    a.download=filename;
    document.body.appendChild(a);
    a.click();
    setTimeout(()=>{ URL.revokeObjectURL(url); a.remove(); }, 0);
  }

  

// ===== Catalog editor (admin) =====
const CAT = { all:[], filtered:[], selectedId:'' };

const setCatMsg = (ok,msg)=> {
  const el = qs('#slbTempleCatMsg');
  if(!el) return;
  el.style.color = ok ? 'inherit' : '#b00000';
  el.textContent = String(msg||'');
};

function catRender(){
  const sel = qs('#slbTempleCatSelect');
  if(!sel) return;
  const opts = (CAT.filtered||[]).map(it=>{
    const id = String(it.itemId||'');
    const title = String(it.title||'');
    return `<option value="${esc(id)}">${esc(id)} — ${esc(title)}</option>`;
  }).join('');
  sel.innerHTML = opts || '<option value="">(no items)</option>';
}

function catApplyFilter(){
  const q = String((qs('#slbTempleCatSearch')||{}).value||'').toLowerCase().trim();
  CAT.filtered = (CAT.all||[]).filter(it=>{
    const id = String(it.itemId||'').toLowerCase();
    const title = String(it.title||'').toLowerCase();
    return !q || id.includes(q) || title.includes(q);
  });
  catRender();
  const sel = qs('#slbTempleCatSelect');
  if(sel && sel.value) catFill(sel.value);
}

function catFill(itemId){
  const it = (CAT.all||[]).find(x=>String(x.itemId||'') === String(itemId||'')) || null;
  CAT.selectedId = it ? String(it.itemId||'') : '';

  const idEl = qs('#slbTempleCatId'); if(idEl) idEl.value = it ? String(it.itemId||'') : '';
  const tEl = qs('#slbTempleCatTitle'); if(tEl) tEl.value = it ? String(it.title||'') : '';
  const bEl = qs('#slbTempleCatBlurb'); if(bEl) bEl.value = it ? String(it.blurb||'') : '';
  const dEl = qs('#slbTempleCatDetails'); if(dEl) dEl.value = it ? String(it.details||'') : '';
  const mEl = qs('#slbTempleCatMin'); if(mEl) mEl.value = it ? String(it.minOffer||108) : '108';
  const sEl = qs('#slbTempleCatSort'); if(sEl) sEl.value = it ? String(it.sortOrder||0) : '0';
  const aEl = qs('#slbTempleCatActive'); if(aEl) aEl.checked = !!Number(it ? it.activeFlag : 0);
}

async function catLoad(){
  if(!qs('#slbTempleCatSelect')) return;
  try{
    setCatMsg(true, 'Loading catalog…');
    const rows = await rpc('adminTempleCatalogList', {});
    CAT.all = Array.isArray(rows) ? rows : [];
    CAT.all.sort((a,b)=> String(a.itemId||'').localeCompare(String(b.itemId||'')));
    CAT.filtered = CAT.all.slice();
    catRender();

    const sel = qs('#slbTempleCatSelect');
    if(sel && sel.options && sel.options.length){
      if(!sel.value) sel.selectedIndex = 0;
      catFill(sel.value);
    }
    setCatMsg(true, `Loaded ${CAT.all.length||0} items.`);
  }catch(e){
    setCatMsg(false, e && e.message ? e.message : String(e));
  }
}

async function catSave(){
  const id = String((qs('#slbTempleCatId')||{}).value||'').trim();
  if(!id){ setCatMsg(false, 'Select an item first.'); return; }

  const payload = {
    itemId: id,
    title: String((qs('#slbTempleCatTitle')||{}).value||'').trim(),
    blurb: String((qs('#slbTempleCatBlurb')||{}).value||'').trim(),
    details: String((qs('#slbTempleCatDetails')||{}).value||'').trim(),
    minOffer: Number((qs('#slbTempleCatMin')||{}).value||0) || 108,
    sortOrder: Number((qs('#slbTempleCatSort')||{}).value||0) || 0,
    activeFlag: (qs('#slbTempleCatActive')||{}).checked ? 1 : 0
  };

  try{
    setCatMsg(true, 'Saving…');
    await rpc('adminTempleCatalogUpsert', payload);
    setCatMsg(true, 'Saved.');
    try{ await loadTemple(); }catch(_e){}
    await catLoad();
    const sel = qs('#slbTempleCatSelect');
    if(sel){ sel.value = id; catFill(id); }
  }catch(e){
    setCatMsg(false, e && e.message ? e.message : String(e));
  }
}

function catWire(){
  const search = qs('#slbTempleCatSearch');
  if(search && !search.__wired){
    search.__wired = true;
    search.addEventListener('input', catApplyFilter);
  }
  const sel = qs('#slbTempleCatSelect');
  if(sel && !sel.__wired){
    sel.__wired = true;
    sel.addEventListener('change', ()=> catFill(sel.value));
  }
  const reload = qs('#slbTempleCatReloadBtn');
  if(reload && !reload.__wired){
    reload.__wired = true;
    reload.addEventListener('click', catLoad);
  }
  const save = qs('#slbTempleCatSaveBtn');
  if(save && !save.__wired){
    save.__wired = true;
    save.addEventListener('click', catSave);
  }
}

  // ===== init =====
  async function init(){
    const mount = null;
    const admMount = qs('#slbTempleAdminMount');
    if(!admMount) return;

    try{ await refreshDash(); }catch(_e){}
    await loadTemple();

    try{ const w=qs('#slbTempleWorshipNext'); if(w) w.style.display='none'; }catch(_e){}

    const bulkBtn=qs('#slbTempleBulkSubmitBtn');
    if(bulkBtn && !bulkBtn.__wired){ bulkBtn.__wired=true; bulkBtn.addEventListener('click', submitBulk); }

    const myRefresh=qs('#slbTempleMyRefreshBtn');
    if(myRefresh && !myRefresh.__wired){ myRefresh.__wired=true; myRefresh.addEventListener('click', loadMy); }

    const myExport=qs('#slbTempleMyExportBtn');
    if(myExport && !myExport.__wired){
      myExport.__wired=true;
      myExport.addEventListener('click', ()=>{
        const rows=[['timeISO','orderId','itemId','title','qty','offering','flyFlag','status','note','archivedFlag']].concat(
          (STATE.my||[]).map(r=>[r.timeISO||'', r.orderId||'', r.itemId||'', r.title||'', r.qty||1, r.offering||0, r.flyFlag||0, r.status||'', r.note||'', r.archivedFlag||0])
        );
        dlCsv('my_temple_orders.csv', rows);
      });
    }

    const myShow = qs('#slbTempleShowArchived');
    if(myShow && !myShow.__wired){
      myShow.__wired = true;
      myShow.addEventListener('change', loadMy);
    }

    if(mount) await loadMy();

    // keep pouch list fresh when dashboard refreshes
    try{ window.addEventListener('slb:dashboard', ()=>{ try{ loadTemple(); }catch(_e){} }); }catch(_e){}

    // admin
    const admRefresh=qs('#slbTempleAdmRefreshBtn');
    if(admRefresh && !admRefresh.__wired){ admRefresh.__wired=true; admRefresh.addEventListener('click', adminRefresh); }
    const admShow=qs('#slbTempleAdmShowArchived');
    if(admShow && !admShow.__wired){ admShow.__wired=true; admShow.addEventListener('change', adminRefresh); }
    const admHideDone=qs('#slbTempleAdmHideDone');
    if(admHideDone && !admHideDone.__wired){ admHideDone.__wired=true; admHideDone.addEventListener('change', adminRefresh); }

    const admExport=qs('#slbTempleAdmExportBtn');
    if(admExport && !admExport.__wired){
      admExport.__wired=true;
      admExport.addEventListener('click', ()=>{
        const rows=[['timeISO','orderId','callsign','itemId','title','qty','offering','flyFlag','pouch','status','note','adminNote','archivedFlag']].concat(
          (STATE.adm||[]).map(r=>[r.timeISO||'', r.orderId||'', r.callsign||'', r.itemId||'', r.title||'', r.qty||1, r.offering||0, r.flyFlag||0, r.payAccountId||'', r.status||'', r.note||'', r.adminNote||'', r.archivedFlag||0])
        );
        dlCsv('temple_admin_orders.csv', rows);
      });
    }

    const admArchiveDoneBtn = qs('#slbTempleAdmArchiveDoneBtn');
    if(admArchiveDoneBtn && !admArchiveDoneBtn.__wired){
      admArchiveDoneBtn.__wired = true;
      admArchiveDoneBtn.addEventListener('click', adminArchiveDone);
    }

    if(admMount){
      try{ await adminRefresh(); }
      catch(e){ try{ setAdmMsg(false, e && e.message ? e.message : String(e)); }catch(_e){} }
    }

    // blocks builder
    const blocksReload=qs('#slbTempleBlocksReloadBtn');
    if(blocksReload && !blocksReload.__wired){ blocksReload.__wired=true; blocksReload.addEventListener('click', blocksLoad); }
    const blocksAddBtn=qs('#slbTempleBlocksAddBtn');
    if(blocksAddBtn && !blocksAddBtn.__wired){ blocksAddBtn.__wired=true; blocksAddBtn.addEventListener('click', blocksAdd); }
    const blocksSaveBtn=qs('#slbTempleBlocksSaveBtn');
    if(blocksSaveBtn && !blocksSaveBtn.__wired){ blocksSaveBtn.__wired=true; blocksSaveBtn.addEventListener('click', blocksSave); }

    catWire();
    if(qs('#slbTempleCatSelect')){
      try{ await catLoad(); }
      catch(e){ try{ setAdmMsg(false, e && e.message ? e.message : String(e)); }catch(_e){} }
    }

    if(qs('#slbTempleBlocksBody')){
      try{ await blocksLoad(); }
      catch(e){ try{ setBlocksMsg(false, e && e.message ? e.message : String(e)); }catch(_e){} }
    }
  }

  // Bootstrap: keep trying until SLB_APP is ready
  let __booting = false;
  function bootstrap(){
    if(__booting) return;
    const adminMount=qs('#slbTempleAdminMount');
    const mount=adminMount;
    if(!mount){ setTimeout(bootstrap, 350); return; }
    const app=getApp();
    if(!app || !app.rpc){ setTimeout(bootstrap, 250); return; }
    __booting = true;
    init().catch(()=>{ __booting=false; setTimeout(bootstrap, 600); });
  }
  document.addEventListener('DOMContentLoaded', ()=>{ setTimeout(bootstrap, 0); });
  setTimeout(bootstrap, 900);

  window.SLB_TEMPLE_ADMIN = { reload: init, state: STATE };
  if(!window.SLB_TEMPLE || !window.SLB_TEMPLE.__acFuRequestV69) window.SLB_TEMPLE = window.SLB_TEMPLE_ADMIN;
})();
/* AC FU Request Game V61 — replaces the old user-facing Temple basket. */
(function(){
  'use strict';
  if(window.__SLB_AC_FU_REQUEST_GAME_V61__) return;
  window.__SLB_AC_FU_REQUEST_GAME_V61__=true;

  var LEGACY_TEMPLE=window.SLB_TEMPLE||null;
  var BG='https://cdn.shopify.com/s/files/1/1299/3411/files/ChatGPT_Image_Jul_30_2026_09_30_26_PM.png?v=1785461436';
  var CACHE_KEY='slb_ac_fu_library_catalog_v61';
  var PREF_KEY='slb_ac_fu_request_pref_v61';
  var S={
    root:null,loaded:false,loading:false,busy:false,catalog:[],filtered:[],pouches:[],orders:[],
    selectedId:'',query:'',category:'ALL',pouchId:'',note:'',showOrders:false,lastError:'',lastResult:null
  };

  function q(sel,root){return (root||document).querySelector(sel)}
  function qa(sel,root){return Array.prototype.slice.call((root||document).querySelectorAll(sel))}
  function esc(v){return String(v==null?'':v).replace(/[&<>"']/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]})}
  function app(){try{return window.SLB_APP||window.SLBAPP||window.SLB||window.slbApp||null}catch(_e){return null}}
  function unwrap(r){if(r&&typeof r==='object'){if(r.ok===false)throw new Error(r.error||r.message||'Request failed.');if(r.result!=null)return r.result;if(r.data!=null)return r.data}return r}
  function rpc(action,args,opts){var a=app();if(!a||typeof a.rpc!=='function')return Promise.reject(new Error('SLB connection is not ready.'));return a.rpc(action,args||{},opts||{}).then(unwrap)}
  function fmt(n){return Math.round(Number(n||0)||0).toLocaleString()}
  function selected(){for(var i=0;i<S.catalog.length;i++)if(String(S.catalog[i].itemId||'')===String(S.selectedId||''))return S.catalog[i];return null}
  function byId(id){for(var i=0;i<S.catalog.length;i++)if(String(S.catalog[i].itemId||'')===String(id||''))return S.catalog[i];return null}
  function cacheRead(){try{var x=JSON.parse(localStorage.getItem(CACHE_KEY)||'null');if(x&&Array.isArray(x.catalog)&&x.catalog.length)return x}catch(_e){}return null}
  function cacheWrite(version,catalog){try{localStorage.setItem(CACHE_KEY,JSON.stringify({version:String(version||''),catalog:catalog||[],savedAt:Date.now()}))}catch(_e){}}
  function prefRead(){try{return JSON.parse(localStorage.getItem(PREF_KEY)||'{}')||{}}catch(_e){return {}}}
  function prefWrite(){try{localStorage.setItem(PREF_KEY,JSON.stringify({pouchId:S.pouchId||'',category:S.category||'ALL'}))}catch(_e){}}
  function categories(){var seen={},out=[];(S.catalog||[]).forEach(function(x){var c=String(x.category||'FU').trim()||'FU';if(!seen[c]){seen[c]=1;out.push(c)}});out.sort(function(a,b){return a.localeCompare(b)});return out}
  function applyFilter(){
    var needle=String(S.query||'').trim().toLowerCase(),cat=String(S.category||'ALL');
    S.filtered=(S.catalog||[]).filter(function(x){
      if(cat!=='ALL'&&String(x.category||'')!==cat)return false;
      if(!needle)return true;
      return [x.itemId,x.code,x.title,x.chineseTitle,x.englishTitle,x.purpose,x.category,x.sourceBook].join(' ').toLowerCase().indexOf(needle)>=0;
    });
    if(!selected()||S.filtered.indexOf(selected())<0)S.selectedId=S.filtered.length?String(S.filtered[0].itemId||''):'';
  }
  function pouchOptions(){
    var rows=S.pouches||[],html='<option value="">Choose a stone pouch…</option>';
    rows.forEach(function(p){var id=String(p.accountId||p.walletId||''),name=String(p.name||p.label||id),bal=Number(p.balance||0)||0;html+='<option value="'+esc(id)+'" '+(id===S.pouchId?'selected':'')+'>'+esc(name)+' — '+fmt(bal)+' stones</option>'});
    return html;
  }
  function categoryOptions(){var html='<option value="ALL">All FU Books</option>';categories().forEach(function(c){html+='<option value="'+esc(c)+'" '+(c===S.category?'selected':'')+'>'+esc(c)+'</option>'});return html}
  function choiceHtml(x){
    var on=String(x.itemId||'')===String(S.selectedId||''),img=String(x.imageUrl||'').trim();
    return '<button type="button" class="acFuChoice '+(on?'on':'')+'" data-acfu-select="'+esc(x.itemId)+'" aria-pressed="'+(on?'true':'false')+'">'+
      '<span class="acFuThumb">'+(img?'<img src="'+esc(img)+'" alt="" loading="lazy">':'<b>FU</b>')+'</span><span><b>'+esc(x.code||x.itemId)+' · '+esc(x.englishTitle||x.title||'FU')+'</b><small>'+esc(x.chineseTitle||'')+(x.category?' · '+esc(x.category):'')+'</small></span></button>';
  }
  function statusHtml(){
    if(S.busy)return '<div class="acFuStatus show work">Submitting the FU request and charging 108 stones…</div>';
    if(S.lastError)return '<div class="acFuStatus show bad">'+esc(S.lastError)+'</div>';
    if(S.lastResult){var ids=(S.lastResult.orderIds||[]).join(', ');return '<div class="acFuStatus show ok"><b>Request submitted.</b> 108 stones were charged and the ticket was emailed to Jee Sifu.'+(ids?'<br>Ticket: '+esc(ids):'')+'</div>'}
    return '<div class="acFuStatus"></div>';
  }
  function orderModalHtml(){
    if(!S.showOrders)return '';
    var rows=S.orders||[],body=rows.length?rows.map(function(r){
      var d='';try{d=new Date(r.timeISO).toLocaleString()}catch(_e){}
      return '<div class="acFuOrder"><b>'+esc(r.title||r.itemId||'FU')+'</b><small>'+esc(d)+' · '+fmt(r.offering||108)+' stones · '+esc(String(r.status||'NEW').toUpperCase())+(r.note?'<br>'+esc(r.note):'')+'</small></div>';
    }).join(''):'<div class="acFuEmpty" style="color:#725e78">No FU requests yet.</div>';
    return '<div class="acFuModal" data-acfu-modal><div class="acFuModalCard"><div class="acFuModalHead"><h3>My AC FU Requests</h3><button type="button" class="acFuClose" data-acfu-close>×</button></div><div class="acFuOrderList">'+body+'</div></div></div>';
  }
  function previewHtml(){
    var x=selected();
    if(!x)return '<section class="acFuPanel acFuPreviewPanel"><div class="acFuEmpty">Choose a FU from the library.</div></section>';
    var img=String(x.imageUrl||'').trim();
    return '<section class="acFuPanel acFuPreviewPanel">'+
      '<div class="acFuImageSide"><div class="acFuImageStage">'+(img?'<img class="acFuMainImage" src="'+esc(img)+'" alt="'+esc(x.imageAlt||x.title||'FU')+'">':'<div class="acFuNoImage">FU</div>')+'</div><div class="acFuImageHint">FU image from '+esc(x.sourceBook||'the Lineage Library')+'</div></div>'+
      '<div class="acFuDetailSide"><span class="acFuCode">'+esc(x.code||x.itemId)+'</span><div class="acFuNames"><h3>'+esc(x.englishTitle||x.title||'FU')+'</h3><div class="zh">'+esc(x.chineseTitle||'')+'</div></div><div class="acFuMeta"><span>'+esc(x.category||'FU')+'</span><span>'+esc(x.sourceBook||'FU Library')+'</span><span>AC Request</span></div>'+
      '<div class="acFuPurpose"><b>FU Purpose</b>'+(esc(x.purpose||'Purpose information is not available for this FU yet.'))+'</div>'+
      '<div class="acFuCheckout"><div class="acFuCheckoutTop"><b>Request this FU from AC</b><span class="acFuStonePrice">108 Stones</span></div><label>Pay from stone pouch<select data-acfu-pouch>'+pouchOptions()+'</select></label><label>Request note <span style="font-weight:500;text-transform:none;letter-spacing:normal">(optional)</span><textarea data-acfu-note maxlength="2000" placeholder="Add a short note about what this FU is for…">'+esc(S.note||'')+'</textarea></label><button type="button" class="acFuRequestBtn" data-acfu-request '+(S.busy?'disabled':'')+'>'+(S.busy?'SUBMITTING…':'REQUEST THIS FU')+'</button>'+statusHtml()+'<div class="acFuFooterActions"><button type="button" class="acFuTextBtn" data-acfu-orders>My Requests</button><button type="button" class="acFuTextBtn" data-acfu-clear>Clear Selection</button></div></div></div></section>';
  }
  function render(){
    if(!S.root)return;
    applyFilter();
    S.root.innerHTML='<div class="acFuScene" style="background-image:url(\''+esc(BG)+'\')">'+
      '<div class="acFuTop"><div class="acFuTitle"><div class="kicker">Ancestral Court · Stone Request</div><h2>Request FU from AC</h2><p>Choose a FU from the Lineage Library. Your 108-stone request is sent to Jee Sifu, who will prepare it and privately give you the deployment code.</p></div><div class="acFuControls"><button type="button" class="acFuIconBtn" data-acfu-full title="Fullscreen">⛶</button><button type="button" class="acFuIconBtn" data-acfu-refresh title="Refresh FU Library">↻</button><button type="button" class="acFuIconBtn" data-acfu-help title="Help">?</button></div></div><div class="acFuPriceBadge">ALL FU REQUESTS · 108 STONES EACH</div>'+
      '<div class="acFuLayout"><aside class="acFuPanel acFuCatalogPanel"><div class="acFuPanelHead"><div><h3>FU Library</h3><p>Select the FU code, read its purpose, and check the actual FU image.</p></div><span class="acFuCount">'+fmt(S.filtered.length)+' / '+fmt(S.catalog.length)+'</span></div><div class="acFuFilters"><input type="search" data-acfu-search value="'+esc(S.query)+'" placeholder="Search code, name, purpose…"><select data-acfu-category>'+categoryOptions()+'</select></div><div class="acFuList">'+(S.filtered.length?S.filtered.map(choiceHtml).join(''):'<div class="acFuEmpty">No FU matches this search.</div>')+'</div></aside>'+previewHtml()+'</div>'+orderModalHtml()+(S.loading&&!S.loaded?'<div class="acFuBusy"><div class="acFuBusyCard">Opening the AC FU Library…</div></div>':'')+'</div>';
    wire();
  }
  function setStatus(error,result){S.lastError=String(error||'');S.lastResult=result||null;render()}
  function loadOrders(){return rpc('templeMyOrders',{limit:100,showArchived:0},{cacheTtlMs:0,progressMode:'silent'}).then(function(rows){S.orders=Array.isArray(rows)?rows:[];if(S.showOrders)render();return S.orders}).catch(function(){return []})}
  function load(force){
    if(S.loading)return Promise.resolve();
    S.loading=true;
    var cached=cacheRead();
    if(!S.catalog.length&&cached&&cached.catalog.length){S.catalog=cached.catalog;S.loaded=true;applyFilter();render()}
    else render();
    return rpc('templeGet',{}, {cacheTtlMs:force?0:300000,noCacheFirst:!!force,progressMode:'silent',timeoutMs:90000}).then(function(out){
      out=out||{};var rows=out.fuCatalog||out.catalog||[];if(Array.isArray(rows)&&rows.length){S.catalog=rows;cacheWrite(out.fuCatalogVersion||(out.settings&&out.settings.catalog_version)||'',rows)}
      S.pouches=Array.isArray(out.pouches)?out.pouches:[];
      var pref=prefRead();
      if(!S.pouchId)S.pouchId=String(pref.pouchId||'');
      if(S.pouchId&&!S.pouches.some(function(p){return String(p.accountId||p.walletId||'')===S.pouchId}))S.pouchId='';
      if(!S.pouchId&&S.pouches.length)S.pouchId=String(S.pouches[0].accountId||S.pouches[0].walletId||'');
      if(!S.selectedId&&S.catalog.length)S.selectedId=String(S.catalog[0].itemId||'');
      S.loaded=true;S.loading=false;S.lastError='';applyFilter();prefWrite();render();loadOrders();
    }).catch(function(e){S.loading=false;S.lastError=String(e&&e.message||e||'The FU Library could not be loaded.');render();throw e})
  }
  function submit(){
    if(S.busy)return;
    var x=selected();if(!x){setStatus('Choose a FU first.');return}
    if(!S.pouchId){setStatus('Choose a stone pouch to pay from.');return}
    S.busy=true;S.lastError='';S.lastResult=null;render();
    rpc('templeOrderCreate',{itemId:x.itemId,pouchId:S.pouchId,note:S.note||'',qty:1,extraOffer:0,flyFu:0},{cacheTtlMs:0,noCacheFirst:true,timeoutMs:120000}).then(function(out){
      S.busy=false;S.note='';S.lastResult=out||{done:true};S.lastError='';render();
      try{var a=app();if(a&&typeof a.refreshDashboardLite==='function')a.refreshDashboardLite({forceFresh:1})}catch(_e){}
      loadOrders();setTimeout(function(){load(true).catch(function(){})},500);
    }).catch(function(e){S.busy=false;S.lastError=String(e&&e.message||e||'The FU request could not be submitted.');render()})
  }
  function toggleFull(){
    if(!S.root)return;
    var scene=q('.acFuScene',S.root);
    try{
      if(document.fullscreenElement){document.exitFullscreen();return}
      if(scene&&scene.requestFullscreen){scene.requestFullscreen();return}
    }catch(_e){}
    S.root.classList.toggle('acFuFullscreen');
  }
  function wire(){
    if(!S.root)return;
    qa('[data-acfu-select]',S.root).forEach(function(b){b.onclick=function(){S.selectedId=String(b.getAttribute('data-acfu-select')||'');S.lastError='';S.lastResult=null;render()}});
    var search=q('[data-acfu-search]',S.root);if(search)search.oninput=function(){var pos=Number(search.selectionStart||String(search.value||'').length);S.query=search.value||'';applyFilter();render();var next=q('[data-acfu-search]',S.root);if(next){try{next.focus();next.setSelectionRange(pos,pos)}catch(_e){}}};
    var cat=q('[data-acfu-category]',S.root);if(cat)cat.onchange=function(){S.category=cat.value||'ALL';prefWrite();applyFilter();render()};
    var pouch=q('[data-acfu-pouch]',S.root);if(pouch)pouch.onchange=function(){S.pouchId=pouch.value||'';prefWrite()};
    var note=q('[data-acfu-note]',S.root);if(note)note.oninput=function(){S.note=note.value||''};
    var request=q('[data-acfu-request]',S.root);if(request)request.onclick=submit;
    var refresh=q('[data-acfu-refresh]',S.root);if(refresh)refresh.onclick=function(){S.lastError='';load(true).catch(function(){})};
    var full=q('[data-acfu-full]',S.root);if(full)full.onclick=toggleFull;
    var help=q('[data-acfu-help]',S.root);if(help)help.onclick=function(){window.alert('Request FU from AC\n\n1. Choose a FU from the FU Library.\n2. Read the purpose and check the FU image.\n3. Choose a stone pouch and submit the 108-stone request.\n4. Jee Sifu receives the ticket by email, prepares the FU, submits it to Saam Law Tin Si, and gives you the deployment code privately.\n\nSLB does not display or deliver the secret code.');};
    var orders=q('[data-acfu-orders]',S.root);if(orders)orders.onclick=function(){S.showOrders=true;render();loadOrders()};
    var close=q('[data-acfu-close]',S.root);if(close)close.onclick=function(){S.showOrders=false;render()};
    var modal=q('[data-acfu-modal]',S.root);if(modal)modal.onclick=function(ev){if(ev.target===modal){S.showOrders=false;render()}};
    var clear=q('[data-acfu-clear]',S.root);if(clear)clear.onclick=function(){S.query='';S.category='ALL';S.selectedId=S.catalog.length?String(S.catalog[0].itemId||''):'';S.note='';S.lastError='';S.lastResult=null;render()};
  }
  function mount(){
    var root=document.getElementById('slbTempleMount');if(!root)return false;S.root=root;
    var pref=prefRead();if(pref.category)S.category=String(pref.category||'ALL');
    render();load(false).catch(function(){});return true
  }
  function bootstrap(){if(!mount())setTimeout(bootstrap,350)}
  document.addEventListener('DOMContentLoaded',function(){setTimeout(bootstrap,0)});
  setTimeout(bootstrap,900);
  document.addEventListener('keydown',function(ev){if(ev.key!=='Escape'||!S.root)return;if(S.showOrders){S.showOrders=false;render();return}if(S.root.classList.contains('acFuFullscreen'))S.root.classList.remove('acFuFullscreen')});

  window.SLB_TEMPLE={reload:function(){var adminMount=document.getElementById('slbTempleAdminMount'),adminPanel=adminMount&&adminMount.closest?adminMount.closest('[data-panel="templeAdmin"]'):null;var legacyWork=Promise.resolve(true);if(adminPanel&&!adminPanel.classList.contains('hidden')&&LEGACY_TEMPLE&&typeof LEGACY_TEMPLE.reload==='function'){try{legacyWork=Promise.resolve(LEGACY_TEMPLE.reload())}catch(_e){}}if(!S.root)mount();else load(false).catch(function(){});return legacyWork},state:S,refresh:function(){return load(true)},legacy:LEGACY_TEMPLE};
})();

/* AC FU Request Game V68 — persistent fullscreen selection and simplified controls. */
(function(){
  'use strict';
  if(window.__SLB_AC_FU_REQUEST_GAME_ACTIVE_VERSION__==='V68') return;
  window.__SLB_AC_FU_REQUEST_GAME_ACTIVE_VERSION__='V68';
  window.__SLB_AC_FU_REQUEST_GAME_V68__=true;

  var LEGACY_TEMPLE=window.SLB_TEMPLE||null;
  var BG='https://cdn.shopify.com/s/files/1/1299/3411/files/ChatGPT_Image_Jul_30_2026_09_30_26_PM.png?v=1785461436';
  var CACHE_KEY='slb_ac_fu_library_catalog_v68';
  var PREF_KEY='slb_ac_fu_request_pref_v68';
  var S={
    root:null,loaded:false,loading:false,busy:false,catalog:[],filtered:[],pouches:[],orders:[],
    selectedId:'',query:'',category:'ALL',pouchId:'',note:'',showOrders:false,lastError:'',lastResult:null,nativeFullActive:false,nativeFullPending:false
  };

  function q(sel,root){return (root||document).querySelector(sel)}
  function qa(sel,root){return Array.prototype.slice.call((root||document).querySelectorAll(sel))}
  function esc(v){return String(v==null?'':v).replace(/[&<>"']/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]})}
  function app(){try{return window.SLB_APP||window.SLBAPP||window.SLB||window.slbApp||null}catch(_e){return null}}
  function unwrap(r){if(r&&typeof r==='object'){if(r.ok===false)throw new Error(r.error||r.message||'Request failed.');if(r.result!=null)return r.result;if(r.data!=null)return r.data}return r}
  function rpc(action,args,opts){var a=app();if(!a||typeof a.rpc!=='function')return Promise.reject(new Error('SLB connection is not ready.'));return a.rpc(action,args||{},opts||{}).then(unwrap)}
  function fmt(n){return Math.round(Number(n||0)||0).toLocaleString()}
  function clean(v){return String(v==null?'':v).trim()}
  function fuCodeFromLibraryItem(row){
    row=row||{};
    var src=[row.image_caption,row.image_alt,row.title,row.english_title,row.chinese_title,row.item_id].join(' ');
    var m=src.match(/\b([A-Z]{1,5}\d{1,3})\b/i);
    if(m&&m[1])return String(m[1]).toUpperCase();
    var first=clean(row.item_id).split('_')[0].replace(/[^A-Za-z0-9]/g,'');
    return first?first.toUpperCase():'FU';
  }
  function localLibraryCatalog(){
    var d=window.TYD_LIBRARY_BOOTSTRAP_V132||window.TYD_LIBRARY_BOOTSTRAP_V140||null;
    if(!d||!Array.isArray(d.items)||!d.items.length)return [];
    var fuBooks={},bookOrder={},bookTitle={};
    (Array.isArray(d.books)?d.books:[]).forEach(function(b){
      var id=clean(b.book_id),title=clean(b.book_title_english||b.english_title||b.directory_group||b.category_group||id);
      if(clean(b.library_type).toUpperCase()==='FU'){
        if(id)fuBooks[id]=1;
        if(title)fuBooks[title]=1;
      }
      if(id){bookOrder[id]=Number(b.display_order||999999)||999999;bookTitle[id]=title;}
      if(title&&!bookOrder[title])bookOrder[title]=Number(b.display_order||999999)||999999;
    });
    var indexBook={};
    (Array.isArray(d.index)?d.index:[]).forEach(function(x){
      var iid=clean(x.item_id),bid=clean(x.book_id),source=clean(x.source_book||bookTitle[bid]||'');
      if(iid&&(fuBooks[bid]||fuBooks[source]))indexBook[iid]={id:bid,title:source||bookTitle[bid]||'',order:bookOrder[bid]||bookOrder[source]||999999};
    });
    var seen={},out=[];
    d.items.forEach(function(row,idx){
      row=row||{};
      var iid=clean(row.item_id),source=clean(row.first_source_book||row.source_book||''),cat=clean(row.category||row.category_group||row.directory_group||source||'FU');
      var indexed=indexBook[iid]||null;
      var isFu=clean(row.type||row.library_type).toUpperCase()==='FU'||!!indexed||!!fuBooks[source]||!!fuBooks[cat];
      if(!isFu)return;
      var status=clean(row.status||'active').toLowerCase();
      if(/^(inactive|archived|draft|hidden|disabled)$/.test(status))return;
      var code=fuCodeFromLibraryItem(row),key=(iid||code).toUpperCase();
      if(!key||seen[key])return;seen[key]=1;
      var chinese=clean(row.chinese_title||row.title_chinese),english=clean(row.english_title||row.title_english||row.title),purpose=clean(row.notes||row.purpose||row.description||row.details||row.blurb||row.short_summary||row.simple_meaning||row.what_it_does||row.practice_usage);
      var image=clean(row.image_url||row.imageUrl||row.image_src||row.image_link||row.artwork_url||row.media_url);
      var srcBook=source||(indexed&&indexed.title)||cat||'FU Library';
      out.push({
        itemId:code,libraryItemId:iid,code:code,type:'FU',
        title:[code,chinese,english].filter(function(v){return !!clean(v)}).join(' '),
        chineseTitle:chinese,englishTitle:english,purpose:purpose,blurb:purpose,details:purpose,
        imageUrl:image,imageAlt:clean(row.image_alt||row.image_caption||[code,chinese,english].join(' ')),
        category:cat||srcBook,sourceBook:srcBook,minOffer:108,fixedPrice:108,activeFlag:1,
        sortOrder:Number((indexed&&indexed.order)||bookOrder[srcBook]||999999)*10000+idx
      });
    });
    out.sort(function(a,b){var ao=Number(a.sortOrder||0),bo=Number(b.sortOrder||0);if(ao!==bo)return ao-bo;return String(a.code||'').localeCompare(String(b.code||''),'en',{numeric:true})});
    return out;
  }
  function catalogVersionLocal(){var d=window.TYD_LIBRARY_BOOTSTRAP_V132||window.TYD_LIBRARY_BOOTSTRAP_V140||{};return 'SAAM_LAW_LIBRARY_'+String(d.v||'')+'_'+String(d.savedAt||d.generatedAt||'')}
  function selected(){for(var i=0;i<S.catalog.length;i++)if(String(S.catalog[i].itemId||'')===String(S.selectedId||''))return S.catalog[i];return null}
  function byId(id){for(var i=0;i<S.catalog.length;i++)if(String(S.catalog[i].itemId||'')===String(id||''))return S.catalog[i];return null}
  function cacheRead(){try{var x=JSON.parse(localStorage.getItem(CACHE_KEY)||'null');if(x&&Array.isArray(x.catalog)&&x.catalog.length)return x}catch(_e){}return null}
  function cacheWrite(version,catalog){try{localStorage.setItem(CACHE_KEY,JSON.stringify({version:String(version||''),catalog:catalog||[],savedAt:Date.now()}))}catch(_e){}}
  function prefRead(){try{return JSON.parse(localStorage.getItem(PREF_KEY)||'{}')||{}}catch(_e){return {}}}
  function prefWrite(){try{localStorage.setItem(PREF_KEY,JSON.stringify({pouchId:S.pouchId||'',category:S.category||'ALL'}))}catch(_e){}}
  function categories(){var seen={},out=[];(S.catalog||[]).forEach(function(x){var c=String(x.category||'FU').trim()||'FU';if(!seen[c]){seen[c]=1;out.push(c)}});out.sort(function(a,b){return a.localeCompare(b)});return out}
  function applyFilter(){
    var needle=String(S.query||'').trim().toLowerCase(),cat=String(S.category||'ALL');
    S.filtered=(S.catalog||[]).filter(function(x){
      if(cat!=='ALL'&&String(x.category||'')!==cat)return false;
      if(!needle)return true;
      return [x.itemId,x.code,x.title,x.chineseTitle,x.englishTitle,x.purpose,x.category,x.sourceBook].join(' ').toLowerCase().indexOf(needle)>=0;
    });
    if(!selected()||S.filtered.indexOf(selected())<0)S.selectedId=S.filtered.length?String(S.filtered[0].itemId||''):'';
  }
  function pouchOptions(){
    var rows=S.pouches||[],html='<option value="">Choose a stone pouch…</option>';
    rows.forEach(function(p){var id=String(p.accountId||p.walletId||''),name=String(p.name||p.label||id),bal=Number(p.balance||0)||0;html+='<option value="'+esc(id)+'" '+(id===S.pouchId?'selected':'')+'>'+esc(name)+' — '+fmt(bal)+' stones</option>'});
    return html;
  }
  function categoryOptions(){var html='<option value="ALL">All FU Books</option>';categories().forEach(function(c){html+='<option value="'+esc(c)+'" '+(c===S.category?'selected':'')+'>'+esc(c)+'</option>'});return html}
  function fitFuPaper(img){
    if(!img)return false;
    var paper=img.closest?img.closest('.acFuPaper'):null,stage=img.closest?img.closest('.acFuImageStage'):null;
    if(!paper||!stage)return false;
    var nw=Number(img.naturalWidth||0),nh=Number(img.naturalHeight||0);
    var stageW=Number(stage.clientWidth||0),stageH=Number(stage.clientHeight||0);
    if(!nw||!nh||stageW<80||stageH<120)return false;
    var sw=Math.max(100,stageW*.84),sh=Math.max(150,stageH*.96);
    var scale=Math.min(sw/nw,sh/nh);
    var w=Math.max(1,Math.floor(nw*scale)),h=Math.max(1,Math.floor(nh*scale));
    paper.style.setProperty('width',w+'px','important');
    paper.style.setProperty('height',h+'px','important');
    paper.style.setProperty('aspect-ratio',nw+' / '+nh,'important');
    img.style.setProperty('width','100%','important');
    img.style.setProperty('height','100%','important');
    img.style.setProperty('max-width','100%','important');
    img.style.setProperty('max-height','100%','important');
    img.style.setProperty('object-fit','fill','important');
    return true;
  }
  function fitVisibleFuPaper(attempt){
    attempt=Number(attempt||0);
    var img=q('.acFuMainImage',S.root);if(!img)return;
    var fitted=fitFuPaper(img);
    if(!fitted&&attempt<10)setTimeout(function(){fitVisibleFuPaper(attempt+1)},60+attempt*35);
    if(!img.__acFuFitBound){
      img.__acFuFitBound=true;
      img.addEventListener('load',function(){requestAnimationFrame(function(){fitFuPaper(img)})},{once:true});
    }
  }
  function choiceHtml(x){
    var on=String(x.itemId||'')===String(S.selectedId||''),img=String(x.imageUrl||'').trim();
    return '<button type="button" class="acFuChoice '+(on?'on':'')+'" data-acfu-select="'+esc(x.itemId)+'" aria-pressed="'+(on?'true':'false')+'">'+
      '<span class="acFuThumb">'+(img?'<img src="'+esc(img)+'" alt="" loading="lazy">':'<b>FU</b>')+'</span><span><b>'+esc(x.code||x.itemId)+' · '+esc(x.englishTitle||x.title||'FU')+'</b><small>'+esc(x.chineseTitle||'')+(x.category?' · '+esc(x.category):'')+'</small></span></button>';
  }
  function statusHtml(){
    if(S.busy)return '<div class="acFuStatus show work">Submitting the FU request and charging 108 stones…</div>';
    if(S.lastError)return '<div class="acFuStatus show bad">'+esc(S.lastError)+'</div>';
    if(S.lastResult){
      var ids=(S.lastResult.orderIds||[]).join(', '),mail=String(S.lastResult.emailStatus||'').toUpperCase();
      var mailText=mail==='SENT'?'The email ticket was sent to Jee Sifu.':(mail==='QUEUED'||mail==='PENDING'?'The request is safely recorded. Email delivery is queued and will retry automatically.':'The request is safely recorded in the backend. Email delivery needs attention.');
      return '<div class="acFuStatus show ok"><b>Request submitted.</b> 108 stones were charged. '+mailText+(ids?'<br>Ticket: '+esc(ids):'')+'</div>'
    }
    return '<div class="acFuStatus"></div>';
  }
  function orderModalHtml(){
    if(!S.showOrders)return '';
    var rows=S.orders||[],body=rows.length?rows.map(function(r){
      var d='';try{d=new Date(r.timeISO).toLocaleString()}catch(_e){}
      return '<div class="acFuOrder"><b>'+esc(r.title||r.itemId||'FU')+'</b><small>'+esc(d)+' · '+fmt(r.offering||108)+' stones · '+esc(String(r.status||'NEW').toUpperCase())+(r.emailStatus?' · EMAIL '+esc(String(r.emailStatus).toUpperCase()):'')+(r.note?'<br>'+esc(r.note):'')+'</small></div>';
    }).join(''):'<div class="acFuEmpty" style="color:#725e78">No FU requests yet.</div>';
    return '<div class="acFuModal" data-acfu-modal><div class="acFuModalCard"><div class="acFuModalHead"><h3 class="acFuModalTitle" style="color:#4a1556!important;-webkit-text-fill-color:#4a1556!important;text-shadow:none!important">My AC FU Requests</h3><button type="button" class="acFuClose" data-acfu-close>×</button></div><div class="acFuOrderList">'+body+'</div></div></div>';
  }
  function previewHtml(){
    var x=selected();
    if(!x)return '<section class="acFuPanel acFuPreviewPanel"><div class="acFuEmpty">Choose a FU from the library.</div></section>';
    var img=String(x.imageUrl||'').trim();
    return '<section class="acFuPanel acFuPreviewPanel">'+
      '<div class="acFuImageSide"><div class="acFuImageStage">'+(img?'<span class="acFuPaper"><img class="acFuMainImage" src="'+esc(img)+'" alt="'+esc(x.imageAlt||x.title||'FU')+'" loading="eager" decoding="async"></span>':'<div class="acFuNoImage">FU</div>')+'</div><div class="acFuImageHint">FU image from '+esc(x.sourceBook||'the Lineage Library')+'</div></div>'+
      '<div class="acFuDetailSide"><span class="acFuCode">'+esc(x.code||x.itemId)+'</span><div class="acFuNames"><h3>'+esc(x.englishTitle||x.title||'FU')+'</h3><div class="zh">'+esc(x.chineseTitle||'')+'</div></div><div class="acFuMeta"><span>'+esc(x.category||'FU')+'</span><span>'+esc(x.sourceBook||'FU Library')+'</span><span>AC Request</span></div>'+
      '<div class="acFuPurpose"><b>FU Purpose</b>'+(esc(x.purpose||'Purpose information is not available for this FU yet.'))+'</div>'+
      '<div class="acFuCheckout"><div class="acFuCheckoutTop"><b>Request this FU from AC</b><span class="acFuStonePrice">108 Stones</span></div><label class="acFuFieldLabel" style="color:#32143b!important;-webkit-text-fill-color:#32143b!important;text-shadow:none!important">Pay from stone pouch<select class="acFuLightField" style="background:#fff!important;background-color:#fff!important;color:#24132c!important;-webkit-text-fill-color:#24132c!important;color-scheme:light!important;filter:none!important;opacity:1!important" data-acfu-pouch>'+pouchOptions()+'</select></label><label class="acFuFieldLabel" style="color:#32143b!important;-webkit-text-fill-color:#32143b!important;text-shadow:none!important">Request note <span style="font-weight:500;text-transform:none;letter-spacing:normal;color:#32143b!important;-webkit-text-fill-color:#32143b!important;text-shadow:none!important">(optional)</span><textarea class="acFuLightField" style="background:#fff!important;background-color:#fff!important;color:#24132c!important;-webkit-text-fill-color:#24132c!important;color-scheme:light!important;filter:none!important;opacity:1!important;caret-color:#24132c!important" data-acfu-note maxlength="2000" placeholder="Add a short note about what this FU is for…">'+esc(S.note||'')+'</textarea></label><button type="button" class="acFuRequestBtn" data-acfu-request '+(S.busy?'disabled':'')+'>'+(S.busy?'SUBMITTING…':'REQUEST THIS FU')+'</button>'+statusHtml()+'<div class="acFuFooterActions"><button type="button" class="acFuTextBtn" data-acfu-orders>My Requests</button><button type="button" class="acFuTextBtn" data-acfu-clear>Clear Selection</button></div></div></div></section>';
  }
  function render(){
    if(!S.root)return;
    applyFilter();
    S.root.innerHTML='<div class="acFuScene" style="background-image:url(\''+esc(BG)+'\')">'+
      '<div class="acFuTop"><div class="acFuTitle"><div class="kicker">Ancestral Court · Stone Request</div><h2>Request FU from AC</h2></div><div class="acFuControls"><button type="button" class="acFuIconBtn" data-acfu-full title="Fullscreen" aria-label="Toggle fullscreen">⛶</button></div></div><div class="acFuPriceBadge">ALL FU REQUESTS · 108 STONES EACH</div>'+
      '<div class="acFuLayout"><aside class="acFuPanel acFuCatalogPanel"><div class="acFuPanelHead"><div><h3>FU Library</h3><p>Select the FU code, read its purpose, and check the actual FU image.</p></div><span class="acFuCount">'+fmt(S.filtered.length)+' / '+fmt(S.catalog.length)+'</span></div><div class="acFuFilters"><input type="search" data-acfu-search value="'+esc(S.query)+'" placeholder="Search code, name, purpose…"><select data-acfu-category>'+categoryOptions()+'</select></div><div class="acFuList">'+(S.filtered.length?S.filtered.map(choiceHtml).join(''):'<div class="acFuEmpty">No FU matches this search.</div>')+'</div></aside>'+previewHtml()+'</div>'+orderModalHtml()+(S.loading&&!S.loaded?'<div class="acFuBusy"><div class="acFuBusyCard">Opening the AC FU Library…</div></div>':'')+'</div>';
    wire();
    requestAnimationFrame(function(){fitVisibleFuPaper(0)});
    setTimeout(function(){fitVisibleFuPaper(0)},120);
    setTimeout(function(){fitVisibleFuPaper(0)},420);
  }
  function setStatus(error,result){S.lastError=String(error||'');S.lastResult=result||null;render()}
  function loadOrders(){return rpc('templeMyOrders',{limit:100,showArchived:0},{cacheTtlMs:0,progressMode:'silent'}).then(function(rows){S.orders=Array.isArray(rows)?rows:[];if(S.showOrders)render();return S.orders}).catch(function(){return []})}
  function load(force){
    if(S.loading)return Promise.resolve();
    S.loading=true;
    var localRows=localLibraryCatalog(),cached=cacheRead();
    if(localRows.length){S.catalog=localRows;S.loaded=true;cacheWrite(catalogVersionLocal(),localRows);applyFilter();render()}
    else if(!S.catalog.length&&cached&&cached.catalog.length){S.catalog=cached.catalog;S.loaded=true;applyFilter();render()}
    else render();
    return rpc('templeGet',{}, {cacheTtlMs:force?0:300000,noCacheFirst:!!force,progressMode:'silent',timeoutMs:90000}).then(function(out){
      out=out||{};var serverRows=out.fuCatalog||out.catalog||[],freshLocal=localLibraryCatalog();
      if(freshLocal.length){S.catalog=freshLocal;cacheWrite(catalogVersionLocal(),freshLocal)}
      else if(Array.isArray(serverRows)&&serverRows.length){S.catalog=serverRows;cacheWrite(out.fuCatalogVersion||(out.settings&&out.settings.catalog_version)||'',serverRows)}
      S.pouches=Array.isArray(out.pouches)?out.pouches:[];
      var pref=prefRead();
      if(!S.pouchId)S.pouchId=String(pref.pouchId||'');
      if(S.pouchId&&!S.pouches.some(function(p){return String(p.accountId||p.walletId||'')===S.pouchId}))S.pouchId='';
      if(!S.pouchId&&S.pouches.length)S.pouchId=String(S.pouches[0].accountId||S.pouches[0].walletId||'');
      if(!S.selectedId&&S.catalog.length)S.selectedId=String(S.catalog[0].itemId||'');
      S.loaded=true;S.loading=false;S.lastError='';applyFilter();prefWrite();render();loadOrders();
    }).catch(function(e){S.loading=false;S.lastError=String(e&&e.message||e||'The FU Library could not be loaded.');render();throw e})
  }
  function submit(){
    if(S.busy)return;
    var x=selected();if(!x){setStatus('Choose a FU first.');return}
    if(!S.pouchId){setStatus('Choose a stone pouch to pay from.');return}
    S.busy=true;S.lastError='';S.lastResult=null;render();
    rpc('templeOrderCreate',{itemId:(x.libraryItemId||x.itemId),pouchId:S.pouchId,note:S.note||'',qty:1,extraOffer:0,flyFu:0},{cacheTtlMs:0,noCacheFirst:true,timeoutMs:120000}).then(function(out){
      S.busy=false;S.note='';S.lastResult=out||{done:true};S.lastError='';render();
      try{var a=app();if(a&&typeof a.refreshDashboardLite==='function')a.refreshDashboardLite({forceFresh:1})}catch(_e){}
      loadOrders();setTimeout(function(){load(true).catch(function(){})},500);
    }).catch(function(e){S.busy=false;S.lastError=String(e&&e.message||e||'The FU request could not be submitted.');render()})
  }
  function nativeFullscreenElement(){return document.fullscreenElement||document.webkitFullscreenElement||null}
  function toggleFull(){
    if(!S.root)return;
    var active=nativeFullscreenElement();
    if(active||S.root.classList.contains('acFuFullscreen')){
      if(active){
        try{
          if(document.exitFullscreen){document.exitFullscreen();return}
          if(document.webkitExitFullscreen){document.webkitExitFullscreen();return}
        }catch(_e){}
      }
      S.nativeFullActive=false;S.nativeFullPending=false;
      S.root.classList.remove('acFuFullscreen');
      setTimeout(function(){fitVisibleFuPaper(0)},40);
      return;
    }
    /* Fullscreen the stable mount, not the rendered scene. Selecting a FU rerenders
       the scene, but the mount remains in the document, so fullscreen is preserved. */
    S.root.classList.add('acFuFullscreen');
    var req=null;
    try{
      if(S.root.requestFullscreen)req=S.root.requestFullscreen();
      else if(S.root.webkitRequestFullscreen)req=S.root.webkitRequestFullscreen();
    }catch(_e){req=null}
    if(req&&typeof req.then==='function'){
      S.nativeFullPending=true;
      req.then(function(){S.nativeFullPending=false;S.nativeFullActive=true;setTimeout(function(){fitVisibleFuPaper(0)},60)}).catch(function(){S.nativeFullPending=false;S.nativeFullActive=false;setTimeout(function(){fitVisibleFuPaper(0)},40)});
    }else{
      S.nativeFullPending=false;
      S.nativeFullActive=!!nativeFullscreenElement();
      setTimeout(function(){fitVisibleFuPaper(0)},40);
    }
  }
  function wire(){
    if(!S.root)return;
    requestAnimationFrame(fitVisibleFuPaper);
    qa('[data-acfu-select]',S.root).forEach(function(b){b.onclick=function(){S.selectedId=String(b.getAttribute('data-acfu-select')||'');S.lastError='';S.lastResult=null;render()}});
    var search=q('[data-acfu-search]',S.root);if(search)search.oninput=function(){var pos=Number(search.selectionStart||String(search.value||'').length);S.query=search.value||'';applyFilter();render();var next=q('[data-acfu-search]',S.root);if(next){try{next.focus();next.setSelectionRange(pos,pos)}catch(_e){}}};
    var cat=q('[data-acfu-category]',S.root);if(cat)cat.onchange=function(){S.category=cat.value||'ALL';prefWrite();applyFilter();render()};
    var pouch=q('[data-acfu-pouch]',S.root);if(pouch)pouch.onchange=function(){S.pouchId=pouch.value||'';prefWrite()};
    var note=q('[data-acfu-note]',S.root);if(note)note.oninput=function(){S.note=note.value||''};
    var request=q('[data-acfu-request]',S.root);if(request)request.onclick=submit;
    var full=q('[data-acfu-full]',S.root);if(full)full.onclick=toggleFull;
    var orders=q('[data-acfu-orders]',S.root);if(orders)orders.onclick=function(){S.showOrders=true;render();loadOrders()};
    var close=q('[data-acfu-close]',S.root);if(close)close.onclick=function(){S.showOrders=false;render()};
    var modal=q('[data-acfu-modal]',S.root);if(modal)modal.onclick=function(ev){if(ev.target===modal){S.showOrders=false;render()}};
    var clear=q('[data-acfu-clear]',S.root);if(clear)clear.onclick=function(){S.query='';S.category='ALL';S.selectedId=S.catalog.length?String(S.catalog[0].itemId||''):'';S.note='';S.lastError='';S.lastResult=null;render()};
  }
  function takeFreshMount(){
    var root=document.getElementById('slbTempleMount');
    if(!root)return null;
    /* A theme update can leave an older AC FU instance alive inside the SLB single-page shell.
       Replace the mount once so every older listener and delayed renderer stays attached to a
       detached node and can no longer overwrite V67 a few seconds later. */
    if(root.getAttribute('data-acfu-owner')!=='V68'){
      var fresh=root.cloneNode(false);
      fresh.setAttribute('data-acfu-owner','V68');
      if(root.parentNode)root.parentNode.replaceChild(fresh,root);
      root=fresh;
    }
    return root;
  }
  function mount(){
    var root=takeFreshMount();if(!root)return false;
    if(S.root===root&&root.isConnected)return true;
    S.root=root;
    var pref=prefRead();if(pref.category)S.category=String(pref.category||'ALL');
    render();load(false).catch(function(){});return true
  }
  function bootstrap(){if(!mount())setTimeout(bootstrap,350)}
  document.addEventListener('DOMContentLoaded',function(){setTimeout(bootstrap,0)});
  setTimeout(bootstrap,900);
  window.addEventListener('resize',function(){if(S.root)requestAnimationFrame(fitVisibleFuPaper)});
  function onFullscreenChange(){
    if(!S.root)return;
    var active=nativeFullscreenElement();
    var owns=!!active&&(active===S.root||(S.root.contains&&S.root.contains(active)));
    if(owns){S.nativeFullActive=true;S.nativeFullPending=false;S.root.classList.add('acFuFullscreen')}
    else if(S.nativeFullActive){S.nativeFullActive=false;S.nativeFullPending=false;S.root.classList.remove('acFuFullscreen')}
    setTimeout(function(){fitVisibleFuPaper(0)},60);
  }
  document.addEventListener('fullscreenchange',onFullscreenChange);
  document.addEventListener('webkitfullscreenchange',onFullscreenChange);
  document.addEventListener('keydown',function(ev){if(ev.key!=='Escape'||!S.root)return;if(S.showOrders){S.showOrders=false;render();return}if(S.root.classList.contains('acFuFullscreen'))S.root.classList.remove('acFuFullscreen')});

  window.SLB_TEMPLE={reload:function(){var adminMount=document.getElementById('slbTempleAdminMount'),adminPanel=adminMount&&adminMount.closest?adminMount.closest('[data-panel="templeAdmin"]'):null;var legacyWork=Promise.resolve(true);if(adminPanel&&!adminPanel.classList.contains('hidden')&&LEGACY_TEMPLE&&typeof LEGACY_TEMPLE.reload==='function'){try{legacyWork=Promise.resolve(LEGACY_TEMPLE.reload())}catch(_e){}}if(!S.root)mount();else load(false).catch(function(){});return legacyWork},state:S,refresh:function(){return load(true)},legacy:LEGACY_TEMPLE};
})();

